var map = {
	"./CustomIcon/IconSuffix/default.svg": 905660,
	"./CustomIcon/IconSuffix/doc.svg": 776669,
	"./CustomIcon/IconSuffix/docx.svg": 97967,
	"./CustomIcon/IconSuffix/dwg.svg": 103449,
	"./CustomIcon/IconSuffix/jpg.svg": 680054,
	"./CustomIcon/IconSuffix/mp3.svg": 467037,
	"./CustomIcon/IconSuffix/mp4.svg": 533106,
	"./CustomIcon/IconSuffix/pdf.svg": 776825,
	"./CustomIcon/IconSuffix/png.svg": 718986,
	"./CustomIcon/IconSuffix/ppt.svg": 363535,
	"./CustomIcon/IconSuffix/pptx.svg": 913125,
	"./CustomIcon/IconSuffix/rar.svg": 395604,
	"./CustomIcon/IconSuffix/tiff.svg": 608648,
	"./CustomIcon/IconSuffix/txt.svg": 223707,
	"./CustomIcon/IconSuffix/xls.svg": 484836,
	"./CustomIcon/IconSuffix/xlsx.svg": 973844,
	"./CustomIcon/Number/0.svg": 142668,
	"./CustomIcon/Number/1.svg": 222381,
	"./CustomIcon/Number/2.svg": 493262,
	"./CustomIcon/Number/3.svg": 898015,
	"./CustomIcon/Number/4.svg": 755808,
	"./CustomIcon/Number/5.svg": 118609,
	"./CustomIcon/Number/6.svg": 147714,
	"./CustomIcon/Number/7.svg": 626707,
	"./CustomIcon/Number/8.svg": 788164,
	"./CustomIcon/Number/9.svg": 742885,
	"./CustomIcon/Number/point.svg": 207366,
	"./CustomIcon/QweatherIcons/100-fill.svg": 13681,
	"./CustomIcon/QweatherIcons/100.svg": 348181,
	"./CustomIcon/QweatherIcons/1001.svg": 399166,
	"./CustomIcon/QweatherIcons/1002.svg": 853341,
	"./CustomIcon/QweatherIcons/1003.svg": 382716,
	"./CustomIcon/QweatherIcons/1004.svg": 457347,
	"./CustomIcon/QweatherIcons/1005.svg": 403058,
	"./CustomIcon/QweatherIcons/1006.svg": 708097,
	"./CustomIcon/QweatherIcons/1007.svg": 995856,
	"./CustomIcon/QweatherIcons/1008.svg": 972423,
	"./CustomIcon/QweatherIcons/1009.svg": 785302,
	"./CustomIcon/QweatherIcons/101-fill.svg": 861110,
	"./CustomIcon/QweatherIcons/101.svg": 806196,
	"./CustomIcon/QweatherIcons/1010.svg": 29804,
	"./CustomIcon/QweatherIcons/1011.svg": 965261,
	"./CustomIcon/QweatherIcons/1012.svg": 670894,
	"./CustomIcon/QweatherIcons/1013.svg": 208831,
	"./CustomIcon/QweatherIcons/1014.svg": 895808,
	"./CustomIcon/QweatherIcons/1015.svg": 336369,
	"./CustomIcon/QweatherIcons/1016.svg": 655970,
	"./CustomIcon/QweatherIcons/1017.svg": 186547,
	"./CustomIcon/QweatherIcons/1018.svg": 296420,
	"./CustomIcon/QweatherIcons/1019.svg": 674437,
	"./CustomIcon/QweatherIcons/102-fill.svg": 885947,
	"./CustomIcon/QweatherIcons/102.svg": 594055,
	"./CustomIcon/QweatherIcons/1020.svg": 272885,
	"./CustomIcon/QweatherIcons/1021.svg": 151252,
	"./CustomIcon/QweatherIcons/1022.svg": 999463,
	"./CustomIcon/QweatherIcons/1023.svg": 52598,
	"./CustomIcon/QweatherIcons/1024.svg": 209433,
	"./CustomIcon/QweatherIcons/1025.svg": 697064,
	"./CustomIcon/QweatherIcons/1026.svg": 612603,
	"./CustomIcon/QweatherIcons/1027.svg": 943786,
	"./CustomIcon/QweatherIcons/1028.svg": 838909,
	"./CustomIcon/QweatherIcons/1029.svg": 226716,
	"./CustomIcon/QweatherIcons/103-fill.svg": 84664,
	"./CustomIcon/QweatherIcons/103.svg": 406934,
	"./CustomIcon/QweatherIcons/1030.svg": 84186,
	"./CustomIcon/QweatherIcons/1031.svg": 886891,
	"./CustomIcon/QweatherIcons/1032.svg": 548056,
	"./CustomIcon/QweatherIcons/1033.svg": 182921,
	"./CustomIcon/QweatherIcons/1034.svg": 580326,
	"./CustomIcon/QweatherIcons/1035.svg": 867863,
	"./CustomIcon/QweatherIcons/1036.svg": 124740,
	"./CustomIcon/QweatherIcons/1037.svg": 79461,
	"./CustomIcon/QweatherIcons/1038.svg": 642,
	"./CustomIcon/QweatherIcons/1039.svg": 963283,
	"./CustomIcon/QweatherIcons/104-fill.svg": 260493,
	"./CustomIcon/QweatherIcons/104.svg": 482169,
	"./CustomIcon/QweatherIcons/1040.svg": 517707,
	"./CustomIcon/QweatherIcons/1041.svg": 640186,
	"./CustomIcon/QweatherIcons/1042.svg": 985001,
	"./CustomIcon/QweatherIcons/1043.svg": 59640,
	"./CustomIcon/QweatherIcons/1044.svg": 904567,
	"./CustomIcon/QweatherIcons/1045.svg": 515590,
	"./CustomIcon/QweatherIcons/1046.svg": 847365,
	"./CustomIcon/QweatherIcons/1047.svg": 350116,
	"./CustomIcon/QweatherIcons/1048.svg": 113395,
	"./CustomIcon/QweatherIcons/1049.svg": 709666,
	"./CustomIcon/QweatherIcons/1050.svg": 706728,
	"./CustomIcon/QweatherIcons/1051.svg": 219097,
	"./CustomIcon/QweatherIcons/1052.svg": 953450,
	"./CustomIcon/QweatherIcons/1053.svg": 622267,
	"./CustomIcon/QweatherIcons/1054.svg": 160916,
	"./CustomIcon/QweatherIcons/1055.svg": 282549,
	"./CustomIcon/QweatherIcons/1056.svg": 62262,
	"./CustomIcon/QweatherIcons/1057.svg": 9127,
	"./CustomIcon/QweatherIcons/1058.svg": 128560,
	"./CustomIcon/QweatherIcons/1059.svg": 219681,
	"./CustomIcon/QweatherIcons/1061.svg": 167536,
	"./CustomIcon/QweatherIcons/1064.svg": 218173,
	"./CustomIcon/QweatherIcons/1101.svg": 516023,
	"./CustomIcon/QweatherIcons/1302.svg": 727542,
	"./CustomIcon/QweatherIcons/1402.svg": 452385,
	"./CustomIcon/QweatherIcons/150-fill.svg": 916184,
	"./CustomIcon/QweatherIcons/150.svg": 167542,
	"./CustomIcon/QweatherIcons/151-fill.svg": 979227,
	"./CustomIcon/QweatherIcons/151.svg": 114407,
	"./CustomIcon/QweatherIcons/152-fill.svg": 107222,
	"./CustomIcon/QweatherIcons/152.svg": 266196,
	"./CustomIcon/QweatherIcons/153-fill.svg": 250961,
	"./CustomIcon/QweatherIcons/153.svg": 387829,
	"./CustomIcon/QweatherIcons/1601.svg": 299264,
	"./CustomIcon/QweatherIcons/1602.svg": 860275,
	"./CustomIcon/QweatherIcons/1603.svg": 456546,
	"./CustomIcon/QweatherIcons/1604.svg": 885069,
	"./CustomIcon/QweatherIcons/1605.svg": 737708,
	"./CustomIcon/QweatherIcons/1606.svg": 916735,
	"./CustomIcon/QweatherIcons/1607.svg": 802094,
	"./CustomIcon/QweatherIcons/2001.svg": 534323,
	"./CustomIcon/QweatherIcons/2002.svg": 243584,
	"./CustomIcon/QweatherIcons/2003.svg": 684145,
	"./CustomIcon/QweatherIcons/2004.svg": 18670,
	"./CustomIcon/QweatherIcons/2005.svg": 556607,
	"./CustomIcon/QweatherIcons/2006.svg": 377580,
	"./CustomIcon/QweatherIcons/2007.svg": 313037,
	"./CustomIcon/QweatherIcons/2008.svg": 87290,
	"./CustomIcon/QweatherIcons/2009.svg": 692555,
	"./CustomIcon/QweatherIcons/2010.svg": 201117,
	"./CustomIcon/QweatherIcons/2011.svg": 730492,
	"./CustomIcon/QweatherIcons/2012.svg": 909519,
	"./CustomIcon/QweatherIcons/2013.svg": 746942,
	"./CustomIcon/QweatherIcons/2014.svg": 55873,
	"./CustomIcon/QweatherIcons/2015.svg": 343632,
	"./CustomIcon/QweatherIcons/2016.svg": 805123,
	"./CustomIcon/QweatherIcons/2017.svg": 750834,
	"./CustomIcon/QweatherIcons/2018.svg": 74325,
	"./CustomIcon/QweatherIcons/2019.svg": 48692,
	"./CustomIcon/QweatherIcons/2020.svg": 644916,
	"./CustomIcon/QweatherIcons/2021.svg": 1173,
	"./CustomIcon/QweatherIcons/2022.svg": 729302,
	"./CustomIcon/QweatherIcons/2023.svg": 493127,
	"./CustomIcon/QweatherIcons/2024.svg": 503944,
	"./CustomIcon/QweatherIcons/2025.svg": 685689,
	"./CustomIcon/QweatherIcons/2026.svg": 594314,
	"./CustomIcon/QweatherIcons/2027.svg": 54683,
	"./CustomIcon/QweatherIcons/2028.svg": 691516,
	"./CustomIcon/QweatherIcons/300-fill.svg": 597387,
	"./CustomIcon/QweatherIcons/300.svg": 913655,
	"./CustomIcon/QweatherIcons/301-fill.svg": 706120,
	"./CustomIcon/QweatherIcons/301.svg": 524678,
	"./CustomIcon/QweatherIcons/302-fill.svg": 653441,
	"./CustomIcon/QweatherIcons/302.svg": 856453,
	"./CustomIcon/QweatherIcons/303-fill.svg": 800070,
	"./CustomIcon/QweatherIcons/303.svg": 359204,
	"./CustomIcon/QweatherIcons/304-fill.svg": 362759,
	"./CustomIcon/QweatherIcons/304.svg": 526795,
	"./CustomIcon/QweatherIcons/305-fill.svg": 627124,
	"./CustomIcon/QweatherIcons/305.svg": 649274,
	"./CustomIcon/QweatherIcons/306-fill.svg": 801309,
	"./CustomIcon/QweatherIcons/306.svg": 994089,
	"./CustomIcon/QweatherIcons/307-fill.svg": 280978,
	"./CustomIcon/QweatherIcons/307.svg": 68728,
	"./CustomIcon/QweatherIcons/308-fill.svg": 41475,
	"./CustomIcon/QweatherIcons/308.svg": 178943,
	"./CustomIcon/QweatherIcons/309-fill.svg": 363456,
	"./CustomIcon/QweatherIcons/309.svg": 64302,
	"./CustomIcon/QweatherIcons/310-fill.svg": 531542,
	"./CustomIcon/QweatherIcons/310.svg": 170004,
	"./CustomIcon/QweatherIcons/311-fill.svg": 675281,
	"./CustomIcon/QweatherIcons/311.svg": 291637,
	"./CustomIcon/QweatherIcons/312-fill.svg": 340504,
	"./CustomIcon/QweatherIcons/312.svg": 71350,
	"./CustomIcon/QweatherIcons/313-fill.svg": 919899,
	"./CustomIcon/QweatherIcons/313.svg": 18215,
	"./CustomIcon/QweatherIcons/314-fill.svg": 195554,
	"./CustomIcon/QweatherIcons/314.svg": 715816,
	"./CustomIcon/QweatherIcons/315-fill.svg": 225005,
	"./CustomIcon/QweatherIcons/315.svg": 228185,
	"./CustomIcon/QweatherIcons/316-fill.svg": 109444,
	"./CustomIcon/QweatherIcons/316.svg": 478890,
	"./CustomIcon/QweatherIcons/317-fill.svg": 513431,
	"./CustomIcon/QweatherIcons/317.svg": 631355,
	"./CustomIcon/QweatherIcons/318-fill.svg": 403342,
	"./CustomIcon/QweatherIcons/318.svg": 245468,
	"./CustomIcon/QweatherIcons/350-fill.svg": 350810,
	"./CustomIcon/QweatherIcons/350.svg": 186288,
	"./CustomIcon/QweatherIcons/351-fill.svg": 58085,
	"./CustomIcon/QweatherIcons/351.svg": 184737,
	"./CustomIcon/QweatherIcons/399-fill.svg": 343665,
	"./CustomIcon/QweatherIcons/399.svg": 621589,
	"./CustomIcon/QweatherIcons/400-fill.svg": 229466,
	"./CustomIcon/QweatherIcons/400.svg": 48176,
	"./CustomIcon/QweatherIcons/401-fill.svg": 453093,
	"./CustomIcon/QweatherIcons/401.svg": 46625,
	"./CustomIcon/QweatherIcons/402-fill.svg": 537692,
	"./CustomIcon/QweatherIcons/402.svg": 164882,
	"./CustomIcon/QweatherIcons/403-fill.svg": 45231,
	"./CustomIcon/QweatherIcons/403.svg": 714275,
	"./CustomIcon/QweatherIcons/404-fill.svg": 666382,
	"./CustomIcon/QweatherIcons/404.svg": 486620,
	"./CustomIcon/QweatherIcons/405-fill.svg": 237769,
	"./CustomIcon/QweatherIcons/405.svg": 98813,
	"./CustomIcon/QweatherIcons/406-fill.svg": 371728,
	"./CustomIcon/QweatherIcons/406.svg": 986718,
	"./CustomIcon/QweatherIcons/407-fill.svg": 980819,
	"./CustomIcon/QweatherIcons/407.svg": 149295,
	"./CustomIcon/QweatherIcons/408-fill.svg": 317922,
	"./CustomIcon/QweatherIcons/408.svg": 991144,
	"./CustomIcon/QweatherIcons/409-fill.svg": 577453,
	"./CustomIcon/QweatherIcons/409.svg": 172889,
	"./CustomIcon/QweatherIcons/410-fill.svg": 119455,
	"./CustomIcon/QweatherIcons/410.svg": 67187,
	"./CustomIcon/QweatherIcons/456-fill.svg": 679965,
	"./CustomIcon/QweatherIcons/456.svg": 855977,
	"./CustomIcon/QweatherIcons/457-fill.svg": 159634,
	"./CustomIcon/QweatherIcons/457.svg": 930616,
	"./CustomIcon/QweatherIcons/499-fill.svg": 97404,
	"./CustomIcon/QweatherIcons/499.svg": 274034,
	"./CustomIcon/QweatherIcons/500-fill.svg": 159021,
	"./CustomIcon/QweatherIcons/500.svg": 683929,
	"./CustomIcon/QweatherIcons/501-fill.svg": 899490,
	"./CustomIcon/QweatherIcons/501.svg": 18536,
	"./CustomIcon/QweatherIcons/502-fill.svg": 941015,
	"./CustomIcon/QweatherIcons/502.svg": 899899,
	"./CustomIcon/QweatherIcons/503-fill.svg": 906436,
	"./CustomIcon/QweatherIcons/503.svg": 357930,
	"./CustomIcon/QweatherIcons/504-fill.svg": 806417,
	"./CustomIcon/QweatherIcons/504.svg": 713205,
	"./CustomIcon/QweatherIcons/507-fill.svg": 347096,
	"./CustomIcon/QweatherIcons/507.svg": 400246,
	"./CustomIcon/QweatherIcons/508-fill.svg": 518309,
	"./CustomIcon/QweatherIcons/508.svg": 557665,
	"./CustomIcon/QweatherIcons/509-fill.svg": 811034,
	"./CustomIcon/QweatherIcons/509.svg": 559216,
	"./CustomIcon/QweatherIcons/510-fill.svg": 238176,
	"./CustomIcon/QweatherIcons/510.svg": 243982,
	"./CustomIcon/QweatherIcons/511-fill.svg": 212323,
	"./CustomIcon/QweatherIcons/511.svg": 72415,
	"./CustomIcon/QweatherIcons/512-fill.svg": 566494,
	"./CustomIcon/QweatherIcons/512.svg": 893388,
	"./CustomIcon/QweatherIcons/513-fill.svg": 90265,
	"./CustomIcon/QweatherIcons/513.svg": 92333,
	"./CustomIcon/QweatherIcons/514-fill.svg": 396268,
	"./CustomIcon/QweatherIcons/514.svg": 805762,
	"./CustomIcon/QweatherIcons/515-fill.svg": 241855,
	"./CustomIcon/QweatherIcons/515.svg": 827283,
	"./CustomIcon/QweatherIcons/800.svg": 530548,
	"./CustomIcon/QweatherIcons/801.svg": 72533,
	"./CustomIcon/QweatherIcons/802.svg": 131286,
	"./CustomIcon/QweatherIcons/803.svg": 318407,
	"./CustomIcon/QweatherIcons/804.svg": 998600,
	"./CustomIcon/QweatherIcons/805.svg": 206521,
	"./CustomIcon/QweatherIcons/806.svg": 445770,
	"./CustomIcon/QweatherIcons/807.svg": 879963,
	"./CustomIcon/QweatherIcons/900-fill.svg": 585433,
	"./CustomIcon/QweatherIcons/900.svg": 789933,
	"./CustomIcon/QweatherIcons/901-fill.svg": 889566,
	"./CustomIcon/QweatherIcons/901.svg": 710220,
	"./CustomIcon/QweatherIcons/999-fill.svg": 471167,
	"./CustomIcon/QweatherIcons/999.svg": 184595,
	"./CustomIcon/QweatherIcons/9998.svg": 251089,
	"./CustomIcon/QweatherIcons/9999.svg": 404640,
	"./CustomIcon/acceptance.svg": 953907,
	"./CustomIcon/acceptance_img.svg": 446963,
	"./CustomIcon/acceptance_select_img.svg": 718458,
	"./CustomIcon/bdmoney.svg": 170796,
	"./CustomIcon/board.svg": 660026,
	"./CustomIcon/dynamicMonitoring/icon_GZCSQ.svg": 18534,
	"./CustomIcon/dynamicMonitoring/icon_KSSTXF.svg": 932257,
	"./CustomIcon/dynamicMonitoring/icon_QYZHZZ.svg": 645716,
	"./CustomIcon/dynamicMonitoring/icon_SSLTHCS.svg": 446172,
	"./CustomIcon/dynamicMonitoring/icon_TDFK.svg": 801829,
	"./CustomIcon/dynamicMonitoring/icon_area.svg": 718807,
	"./CustomIcon/dynamicMonitoring/icon_distance.svg": 900517,
	"./CustomIcon/dynamicMonitoring/icon_swipe.svg": 835674,
	"./CustomIcon/export.svg": 132748,
	"./CustomIcon/filing.svg": 124569,
	"./CustomIcon/filing_img.svg": 237633,
	"./CustomIcon/filing_select_img.svg": 87656,
	"./CustomIcon/h_icon_back.svg": 79964,
	"./CustomIcon/hektare.svg": 764796,
	"./CustomIcon/icon-bdmoney.svg": 298976,
	"./CustomIcon/icon-export.svg": 201336,
	"./CustomIcon/icon-landArea.svg": 803882,
	"./CustomIcon/icon_back.svg": 640061,
	"./CustomIcon/icon_download.svg": 720140,
	"./CustomIcon/icon_folder.svg": 986416,
	"./CustomIcon/icon_hide.svg": 834852,
	"./CustomIcon/icon_upload.svg": 762527,
	"./CustomIcon/icon_view.svg": 287255,
	"./CustomIcon/implement.svg": 794885,
	"./CustomIcon/implement_img.svg": 216453,
	"./CustomIcon/implement_select_img.svg": 841932,
	"./CustomIcon/landArea.svg": 367542,
	"./CustomIcon/list.svg": 208238,
	"./CustomIcon/mine.svg": 805231,
	"./CustomIcon/money.svg": 872482,
	"./CustomIcon/more-color.svg": 636955,
	"./CustomIcon/overdue.svg": 956738,
	"./CustomIcon/overdue_img.svg": 230734,
	"./CustomIcon/overdue_select_img.svg": 609793,
	"./CustomIcon/pigeonhole.svg": 401862,
	"./CustomIcon/pigeonhole_img.svg": 870202,
	"./CustomIcon/pigeonhole_select_img.svg": 392861,
	"./CustomIcon/production_area.svg": 292137,
	"./CustomIcon/production_location.svg": 572671,
	"./CustomIcon/production_mine.svg": 241223,
	"./CustomIcon/step/icon_acceptance.svg": 947650,
	"./CustomIcon/step/icon_acceptance_default.svg": 792364,
	"./CustomIcon/step/icon_acceptance_select.svg": 10585,
	"./CustomIcon/step/icon_archive.svg": 461051,
	"./CustomIcon/step/icon_archive_default.svg": 670549,
	"./CustomIcon/step/icon_archive_select.svg": 909950,
	"./CustomIcon/step/icon_implement.svg": 710966,
	"./CustomIcon/step/icon_implement_default.svg": 368968,
	"./CustomIcon/step/icon_implement_select.svg": 27837,
	"./CustomIcon/step/icon_plan.svg": 823346,
	"./CustomIcon/step/icon_plan_default.svg": 608956,
	"./CustomIcon/step/icon_plan_select.svg": 954633,
	"./CustomIcon/visualScreen.svg": 485490,
	"./Picture/duobianxing.svg": 377094,
	"./Picture/juxing.svg": 130495,
	"./RemixIcon/Buildings/ancient-gate-fill.svg": 679694,
	"./RemixIcon/Buildings/ancient-gate-line.svg": 937475,
	"./RemixIcon/Buildings/ancient-pavilion-fill.svg": 324037,
	"./RemixIcon/Buildings/ancient-pavilion-line.svg": 542728,
	"./RemixIcon/Buildings/bank-fill.svg": 110556,
	"./RemixIcon/Buildings/bank-line.svg": 846105,
	"./RemixIcon/Buildings/building-2-fill.svg": 526089,
	"./RemixIcon/Buildings/building-2-line.svg": 256236,
	"./RemixIcon/Buildings/building-3-fill.svg": 954702,
	"./RemixIcon/Buildings/building-3-line.svg": 233283,
	"./RemixIcon/Buildings/building-4-fill.svg": 333551,
	"./RemixIcon/Buildings/building-4-line.svg": 1098,
	"./RemixIcon/Buildings/building-fill.svg": 908122,
	"./RemixIcon/Buildings/building-line.svg": 40303,
	"./RemixIcon/Buildings/community-fill.svg": 292299,
	"./RemixIcon/Buildings/community-line.svg": 20934,
	"./RemixIcon/Buildings/government-fill.svg": 110969,
	"./RemixIcon/Buildings/government-line.svg": 267676,
	"./RemixIcon/Buildings/home-2-fill.svg": 373646,
	"./RemixIcon/Buildings/home-2-line.svg": 652227,
	"./RemixIcon/Buildings/home-3-fill.svg": 945033,
	"./RemixIcon/Buildings/home-3-line.svg": 675180,
	"./RemixIcon/Buildings/home-4-fill.svg": 244956,
	"./RemixIcon/Buildings/home-4-line.svg": 980505,
	"./RemixIcon/Buildings/home-5-fill.svg": 752495,
	"./RemixIcon/Buildings/home-5-line.svg": 420042,
	"./RemixIcon/Buildings/home-6-fill.svg": 936730,
	"./RemixIcon/Buildings/home-6-line.svg": 585263,
	"./RemixIcon/Buildings/home-7-fill.svg": 160357,
	"./RemixIcon/Buildings/home-7-line.svg": 536616,
	"./RemixIcon/Buildings/home-8-fill.svg": 989144,
	"./RemixIcon/Buildings/home-8-line.svg": 19301,
	"./RemixIcon/Buildings/home-fill.svg": 153833,
	"./RemixIcon/Buildings/home-gear-fill.svg": 570215,
	"./RemixIcon/Buildings/home-gear-line.svg": 588930,
	"./RemixIcon/Buildings/home-heart-fill.svg": 173088,
	"./RemixIcon/Buildings/home-heart-line.svg": 296973,
	"./RemixIcon/Buildings/home-line.svg": 447948,
	"./RemixIcon/Buildings/home-smile-2-fill.svg": 30043,
	"./RemixIcon/Buildings/home-smile-2-line.svg": 350870,
	"./RemixIcon/Buildings/home-smile-fill.svg": 570720,
	"./RemixIcon/Buildings/home-smile-line.svg": 210957,
	"./RemixIcon/Buildings/home-wifi-fill.svg": 273109,
	"./RemixIcon/Buildings/home-wifi-line.svg": 235416,
	"./RemixIcon/Buildings/hospital-fill.svg": 912500,
	"./RemixIcon/Buildings/hospital-line.svg": 888849,
	"./RemixIcon/Buildings/hotel-fill.svg": 85952,
	"./RemixIcon/Buildings/hotel-line.svg": 679277,
	"./RemixIcon/Buildings/store-2-fill.svg": 472856,
	"./RemixIcon/Buildings/store-2-line.svg": 755941,
	"./RemixIcon/Buildings/store-3-fill.svg": 52251,
	"./RemixIcon/Buildings/store-3-line.svg": 754134,
	"./RemixIcon/Buildings/store-fill.svg": 473487,
	"./RemixIcon/Buildings/store-line.svg": 658090,
	"./RemixIcon/Business/advertisement-fill.svg": 214732,
	"./RemixIcon/Business/advertisement-line.svg": 669385,
	"./RemixIcon/Business/archive-drawer-fill.svg": 966659,
	"./RemixIcon/Business/archive-drawer-line.svg": 458526,
	"./RemixIcon/Business/archive-fill.svg": 40491,
	"./RemixIcon/Business/archive-line.svg": 654630,
	"./RemixIcon/Business/at-fill.svg": 994234,
	"./RemixIcon/Business/at-line.svg": 347087,
	"./RemixIcon/Business/attachment-fill.svg": 834826,
	"./RemixIcon/Business/attachment-line.svg": 384351,
	"./RemixIcon/Business/award-fill.svg": 293060,
	"./RemixIcon/Business/award-line.svg": 981025,
	"./RemixIcon/Business/bar-chart-2-fill.svg": 327026,
	"./RemixIcon/Business/bar-chart-2-line.svg": 629063,
	"./RemixIcon/Business/bar-chart-box-fill.svg": 943281,
	"./RemixIcon/Business/bar-chart-box-line.svg": 620596,
	"./RemixIcon/Business/bar-chart-fill.svg": 339477,
	"./RemixIcon/Business/bar-chart-grouped-fill.svg": 793174,
	"./RemixIcon/Business/bar-chart-grouped-line.svg": 656555,
	"./RemixIcon/Business/bar-chart-horizontal-fill.svg": 854876,
	"./RemixIcon/Business/bar-chart-horizontal-line.svg": 213593,
	"./RemixIcon/Business/bar-chart-line.svg": 612376,
	"./RemixIcon/Business/bookmark-2-fill.svg": 294752,
	"./RemixIcon/Business/bookmark-2-line.svg": 71117,
	"./RemixIcon/Business/bookmark-3-fill.svg": 268899,
	"./RemixIcon/Business/bookmark-3-line.svg": 107582,
	"./RemixIcon/Business/bookmark-fill.svg": 483367,
	"./RemixIcon/Business/bookmark-line.svg": 502082,
	"./RemixIcon/Business/briefcase-2-fill.svg": 928586,
	"./RemixIcon/Business/briefcase-2-line.svg": 523167,
	"./RemixIcon/Business/briefcase-3-fill.svg": 623317,
	"./RemixIcon/Business/briefcase-3-line.svg": 585624,
	"./RemixIcon/Business/briefcase-4-fill.svg": 196224,
	"./RemixIcon/Business/briefcase-4-line.svg": 273197,
	"./RemixIcon/Business/briefcase-5-fill.svg": 357891,
	"./RemixIcon/Business/briefcase-5-line.svg": 654750,
	"./RemixIcon/Business/briefcase-fill.svg": 457949,
	"./RemixIcon/Business/briefcase-line.svg": 130592,
	"./RemixIcon/Business/bubble-chart-fill.svg": 565568,
	"./RemixIcon/Business/bubble-chart-line.svg": 501869,
	"./RemixIcon/Business/calculator-fill.svg": 786755,
	"./RemixIcon/Business/calculator-line.svg": 278622,
	"./RemixIcon/Business/calendar-2-fill.svg": 233542,
	"./RemixIcon/Business/calendar-2-line.svg": 528667,
	"./RemixIcon/Business/calendar-check-fill.svg": 108260,
	"./RemixIcon/Business/calendar-check-line.svg": 519425,
	"./RemixIcon/Business/calendar-event-fill.svg": 793640,
	"./RemixIcon/Business/calendar-event-line.svg": 755637,
	"./RemixIcon/Business/calendar-fill.svg": 504849,
	"./RemixIcon/Business/calendar-line.svg": 794260,
	"./RemixIcon/Business/calendar-todo-fill.svg": 427892,
	"./RemixIcon/Business/calendar-todo-line.svg": 887889,
	"./RemixIcon/Business/cloud-fill.svg": 782012,
	"./RemixIcon/Business/cloud-line.svg": 11513,
	"./RemixIcon/Business/cloud-off-fill.svg": 60556,
	"./RemixIcon/Business/cloud-off-line.svg": 31561,
	"./RemixIcon/Business/copyleft-fill.svg": 247243,
	"./RemixIcon/Business/copyleft-line.svg": 40390,
	"./RemixIcon/Business/copyright-fill.svg": 155740,
	"./RemixIcon/Business/copyright-line.svg": 374937,
	"./RemixIcon/Business/creative-commons-by-fill.svg": 689537,
	"./RemixIcon/Business/creative-commons-by-line.svg": 865860,
	"./RemixIcon/Business/creative-commons-fill.svg": 342385,
	"./RemixIcon/Business/creative-commons-line.svg": 896948,
	"./RemixIcon/Business/creative-commons-nc-fill.svg": 742479,
	"./RemixIcon/Business/creative-commons-nc-line.svg": 927082,
	"./RemixIcon/Business/creative-commons-nd-fill.svg": 361710,
	"./RemixIcon/Business/creative-commons-nd-line.svg": 985571,
	"./RemixIcon/Business/creative-commons-sa-fill.svg": 86000,
	"./RemixIcon/Business/creative-commons-sa-line.svg": 995997,
	"./RemixIcon/Business/creative-commons-zero-fill.svg": 636014,
	"./RemixIcon/Business/creative-commons-zero-line.svg": 532451,
	"./RemixIcon/Business/customer-service-2-fill.svg": 121654,
	"./RemixIcon/Business/customer-service-2-line.svg": 278539,
	"./RemixIcon/Business/customer-service-fill.svg": 309345,
	"./RemixIcon/Business/customer-service-line.svg": 296036,
	"./RemixIcon/Business/donut-chart-fill.svg": 898304,
	"./RemixIcon/Business/donut-chart-line.svg": 350957,
	"./RemixIcon/Business/flag-2-fill.svg": 819246,
	"./RemixIcon/Business/flag-2-line.svg": 959459,
	"./RemixIcon/Business/flag-fill.svg": 773513,
	"./RemixIcon/Business/flag-line.svg": 503660,
	"./RemixIcon/Business/global-fill.svg": 581772,
	"./RemixIcon/Business/global-line.svg": 613129,
	"./RemixIcon/Business/honour-fill.svg": 25270,
	"./RemixIcon/Business/honour-line.svg": 62923,
	"./RemixIcon/Business/inbox-archive-fill.svg": 736042,
	"./RemixIcon/Business/inbox-archive-line.svg": 569151,
	"./RemixIcon/Business/inbox-fill.svg": 236213,
	"./RemixIcon/Business/inbox-line.svg": 621496,
	"./RemixIcon/Business/inbox-unarchive-fill.svg": 330999,
	"./RemixIcon/Business/inbox-unarchive-line.svg": 546002,
	"./RemixIcon/Business/line-chart-fill.svg": 314248,
	"./RemixIcon/Business/line-chart-line.svg": 655509,
	"./RemixIcon/Business/links-fill.svg": 795276,
	"./RemixIcon/Business/links-line.svg": 249929,
	"./RemixIcon/Business/mail-add-fill.svg": 671010,
	"./RemixIcon/Business/mail-add-line.svg": 366775,
	"./RemixIcon/Business/mail-check-fill.svg": 520053,
	"./RemixIcon/Business/mail-check-line.svg": 388984,
	"./RemixIcon/Business/mail-close-fill.svg": 230809,
	"./RemixIcon/Business/mail-close-line.svg": 442428,
	"./RemixIcon/Business/mail-download-fill.svg": 495179,
	"./RemixIcon/Business/mail-download-line.svg": 288326,
	"./RemixIcon/Business/mail-fill.svg": 677100,
	"./RemixIcon/Business/mail-forbid-fill.svg": 296329,
	"./RemixIcon/Business/mail-forbid-line.svg": 510124,
	"./RemixIcon/Business/mail-line.svg": 422249,
	"./RemixIcon/Business/mail-lock-fill.svg": 990836,
	"./RemixIcon/Business/mail-lock-line.svg": 175185,
	"./RemixIcon/Business/mail-open-fill.svg": 380651,
	"./RemixIcon/Business/mail-open-line.svg": 511142,
	"./RemixIcon/Business/mail-send-fill.svg": 659109,
	"./RemixIcon/Business/mail-send-line.svg": 686696,
	"./RemixIcon/Business/mail-settings-fill.svg": 323854,
	"./RemixIcon/Business/mail-settings-line.svg": 602435,
	"./RemixIcon/Business/mail-star-fill.svg": 320163,
	"./RemixIcon/Business/mail-star-line.svg": 642494,
	"./RemixIcon/Business/mail-unread-fill.svg": 490932,
	"./RemixIcon/Business/mail-unread-line.svg": 191633,
	"./RemixIcon/Business/mail-volume-fill.svg": 379181,
	"./RemixIcon/Business/mail-volume-line.svg": 262192,
	"./RemixIcon/Business/medal-2-fill.svg": 187213,
	"./RemixIcon/Business/medal-2-line.svg": 607760,
	"./RemixIcon/Business/medal-fill.svg": 324902,
	"./RemixIcon/Business/medal-line.svg": 3195,
	"./RemixIcon/Business/pie-chart-2-fill.svg": 606849,
	"./RemixIcon/Business/pie-chart-2-line.svg": 454148,
	"./RemixIcon/Business/pie-chart-box-fill.svg": 553578,
	"./RemixIcon/Business/pie-chart-box-line.svg": 396607,
	"./RemixIcon/Business/pie-chart-fill.svg": 704930,
	"./RemixIcon/Business/pie-chart-line.svg": 884343,
	"./RemixIcon/Business/printer-cloud-fill.svg": 503901,
	"./RemixIcon/Business/printer-cloud-line.svg": 16672,
	"./RemixIcon/Business/printer-fill.svg": 409569,
	"./RemixIcon/Business/printer-line.svg": 676964,
	"./RemixIcon/Business/profile-fill.svg": 114780,
	"./RemixIcon/Business/profile-line.svg": 850329,
	"./RemixIcon/Business/projector-2-fill.svg": 654282,
	"./RemixIcon/Business/projector-2-line.svg": 203807,
	"./RemixIcon/Business/projector-fill.svg": 536541,
	"./RemixIcon/Business/projector-line.svg": 49312,
	"./RemixIcon/Business/record-mail-fill.svg": 860902,
	"./RemixIcon/Business/record-mail-line.svg": 539195,
	"./RemixIcon/Business/registered-fill.svg": 240671,
	"./RemixIcon/Business/registered-line.svg": 47738,
	"./RemixIcon/Business/reply-all-fill.svg": 855987,
	"./RemixIcon/Business/reply-all-line.svg": 288782,
	"./RemixIcon/Business/reply-fill.svg": 494777,
	"./RemixIcon/Business/reply-line.svg": 588828,
	"./RemixIcon/Business/send-plane-2-fill.svg": 697945,
	"./RemixIcon/Business/send-plane-2-line.svg": 803068,
	"./RemixIcon/Business/send-plane-fill.svg": 505290,
	"./RemixIcon/Business/send-plane-line.svg": 99871,
	"./RemixIcon/Business/service-fill.svg": 439422,
	"./RemixIcon/Business/service-line.svg": 907443,
	"./RemixIcon/Business/slideshow-2-fill.svg": 206690,
	"./RemixIcon/Business/slideshow-2-line.svg": 902455,
	"./RemixIcon/Business/slideshow-3-fill.svg": 752493,
	"./RemixIcon/Business/slideshow-3-line.svg": 439856,
	"./RemixIcon/Business/slideshow-4-fill.svg": 867992,
	"./RemixIcon/Business/slideshow-4-line.svg": 634725,
	"./RemixIcon/Business/slideshow-fill.svg": 189989,
	"./RemixIcon/Business/slideshow-line.svg": 701224,
	"./RemixIcon/Business/stack-fill.svg": 550481,
	"./RemixIcon/Business/stack-line.svg": 436244,
	"./RemixIcon/Business/trademark-fill.svg": 892006,
	"./RemixIcon/Business/trademark-line.svg": 570299,
	"./RemixIcon/Business/window-2-fill.svg": 25860,
	"./RemixIcon/Business/window-2-line.svg": 713825,
	"./RemixIcon/Business/window-fill.svg": 419443,
	"./RemixIcon/Business/window-line.svg": 335886,
	"./RemixIcon/Communication/chat-1-fill.svg": 615553,
	"./RemixIcon/Communication/chat-1-line.svg": 791876,
	"./RemixIcon/Communication/chat-2-fill.svg": 668232,
	"./RemixIcon/Communication/chat-2-line.svg": 916437,
	"./RemixIcon/Communication/chat-3-fill.svg": 559499,
	"./RemixIcon/Communication/chat-3-line.svg": 868998,
	"./RemixIcon/Communication/chat-4-fill.svg": 243090,
	"./RemixIcon/Communication/chat-4-line.svg": 739623,
	"./RemixIcon/Communication/chat-check-fill.svg": 336790,
	"./RemixIcon/Communication/chat-check-line.svg": 716523,
	"./RemixIcon/Communication/chat-delete-fill.svg": 841921,
	"./RemixIcon/Communication/chat-delete-line.svg": 18244,
	"./RemixIcon/Communication/chat-download-fill.svg": 970822,
	"./RemixIcon/Communication/chat-download-line.svg": 782299,
	"./RemixIcon/Communication/chat-follow-up-fill.svg": 250903,
	"./RemixIcon/Communication/chat-follow-up-line.svg": 708018,
	"./RemixIcon/Communication/chat-forward-fill.svg": 348183,
	"./RemixIcon/Communication/chat-forward-line.svg": 805298,
	"./RemixIcon/Communication/chat-heart-fill.svg": 756874,
	"./RemixIcon/Communication/chat-heart-line.svg": 822751,
	"./RemixIcon/Communication/chat-history-fill.svg": 363678,
	"./RemixIcon/Communication/chat-history-line.svg": 183891,
	"./RemixIcon/Communication/chat-new-fill.svg": 149624,
	"./RemixIcon/Communication/chat-new-line.svg": 313349,
	"./RemixIcon/Communication/chat-off-fill.svg": 525495,
	"./RemixIcon/Communication/chat-off-line.svg": 775890,
	"./RemixIcon/Communication/chat-poll-fill.svg": 166951,
	"./RemixIcon/Communication/chat-poll-line.svg": 462082,
	"./RemixIcon/Communication/chat-private-fill.svg": 812737,
	"./RemixIcon/Communication/chat-private-line.svg": 660036,
	"./RemixIcon/Communication/chat-quote-fill.svg": 389746,
	"./RemixIcon/Communication/chat-quote-line.svg": 691783,
	"./RemixIcon/Communication/chat-settings-fill.svg": 754007,
	"./RemixIcon/Communication/chat-settings-line.svg": 856242,
	"./RemixIcon/Communication/chat-smile-2-fill.svg": 653705,
	"./RemixIcon/Communication/chat-smile-2-line.svg": 867500,
	"./RemixIcon/Communication/chat-smile-3-fill.svg": 82318,
	"./RemixIcon/Communication/chat-smile-3-line.svg": 360899,
	"./RemixIcon/Communication/chat-smile-fill.svg": 664602,
	"./RemixIcon/Communication/chat-smile-line.svg": 796783,
	"./RemixIcon/Communication/chat-upload-fill.svg": 282507,
	"./RemixIcon/Communication/chat-upload-line.svg": 494790,
	"./RemixIcon/Communication/chat-voice-fill.svg": 747180,
	"./RemixIcon/Communication/chat-voice-line.svg": 492329,
	"./RemixIcon/Communication/discuss-fill.svg": 527033,
	"./RemixIcon/Communication/discuss-line.svg": 104732,
	"./RemixIcon/Communication/feedback-fill.svg": 206318,
	"./RemixIcon/Communication/feedback-line.svg": 830179,
	"./RemixIcon/Communication/message-2-fill.svg": 697055,
	"./RemixIcon/Communication/message-2-line.svg": 504122,
	"./RemixIcon/Communication/message-3-fill.svg": 13452,
	"./RemixIcon/Communication/message-3-line.svg": 984457,
	"./RemixIcon/Communication/message-fill.svg": 970860,
	"./RemixIcon/Communication/message-line.svg": 173481,
	"./RemixIcon/Communication/question-answer-fill.svg": 94638,
	"./RemixIcon/Communication/question-answer-line.svg": 474723,
	"./RemixIcon/Communication/questionnaire-fill.svg": 894822,
	"./RemixIcon/Communication/questionnaire-line.svg": 573115,
	"./RemixIcon/Communication/video-chat-fill.svg": 695309,
	"./RemixIcon/Communication/video-chat-line.svg": 115856,
	"./RemixIcon/Design/anticlockwise-2-fill.svg": 442360,
	"./RemixIcon/Design/anticlockwise-2-line.svg": 486853,
	"./RemixIcon/Design/anticlockwise-fill.svg": 635183,
	"./RemixIcon/Design/anticlockwise-line.svg": 6730,
	"./RemixIcon/Design/artboard-2-fill.svg": 927967,
	"./RemixIcon/Design/artboard-2-line.svg": 452410,
	"./RemixIcon/Design/artboard-fill.svg": 968236,
	"./RemixIcon/Design/artboard-line.svg": 713385,
	"./RemixIcon/Design/ball-pen-fill.svg": 913584,
	"./RemixIcon/Design/ball-pen-line.svg": 339933,
	"./RemixIcon/Design/blur-off-fill.svg": 155434,
	"./RemixIcon/Design/blur-off-line.svg": 998463,
	"./RemixIcon/Design/brush-2-fill.svg": 618902,
	"./RemixIcon/Design/brush-2-line.svg": 998635,
	"./RemixIcon/Design/brush-3-fill.svg": 762641,
	"./RemixIcon/Design/brush-3-line.svg": 52052,
	"./RemixIcon/Design/brush-4-fill.svg": 196804,
	"./RemixIcon/Design/brush-4-line.svg": 884769,
	"./RemixIcon/Design/brush-fill.svg": 991169,
	"./RemixIcon/Design/brush-line.svg": 167492,
	"./RemixIcon/Design/clockwise-2-fill.svg": 74176,
	"./RemixIcon/Design/clockwise-2-line.svg": 151149,
	"./RemixIcon/Design/clockwise-fill.svg": 487175,
	"./RemixIcon/Design/clockwise-line.svg": 377826,
	"./RemixIcon/Design/collage-fill.svg": 513280,
	"./RemixIcon/Design/collage-line.svg": 106605,
	"./RemixIcon/Design/compasses-2-fill.svg": 955258,
	"./RemixIcon/Design/compasses-2-line.svg": 693839,
	"./RemixIcon/Design/compasses-fill.svg": 534893,
	"./RemixIcon/Design/compasses-line.svg": 901552,
	"./RemixIcon/Design/contrast-2-fill.svg": 376070,
	"./RemixIcon/Design/contrast-2-line.svg": 90331,
	"./RemixIcon/Design/contrast-drop-2-fill.svg": 704994,
	"./RemixIcon/Design/contrast-drop-2-line.svg": 148215,
	"./RemixIcon/Design/contrast-drop-fill.svg": 314149,
	"./RemixIcon/Design/contrast-drop-line.svg": 206760,
	"./RemixIcon/Design/contrast-fill.svg": 168337,
	"./RemixIcon/Design/contrast-line.svg": 54100,
	"./RemixIcon/Design/crop-2-fill.svg": 308738,
	"./RemixIcon/Design/crop-2-line.svg": 469335,
	"./RemixIcon/Design/crop-fill.svg": 757125,
	"./RemixIcon/Design/crop-line.svg": 975816,
	"./RemixIcon/Design/drag-drop-fill.svg": 769941,
	"./RemixIcon/Design/drag-drop-line.svg": 732248,
	"./RemixIcon/Design/drag-move-2-fill.svg": 246170,
	"./RemixIcon/Design/drag-move-2-line.svg": 173423,
	"./RemixIcon/Design/drag-move-fill.svg": 492045,
	"./RemixIcon/Design/drag-move-line.svg": 307408,
	"./RemixIcon/Design/drop-fill.svg": 978490,
	"./RemixIcon/Design/drop-line.svg": 331343,
	"./RemixIcon/Design/edit-2-fill.svg": 807436,
	"./RemixIcon/Design/edit-2-line.svg": 262089,
	"./RemixIcon/Design/edit-box-fill.svg": 698911,
	"./RemixIcon/Design/edit-box-line.svg": 505978,
	"./RemixIcon/Design/edit-circle-fill.svg": 671030,
	"./RemixIcon/Design/edit-circle-line.svg": 827915,
	"./RemixIcon/Design/edit-fill.svg": 615083,
	"./RemixIcon/Design/edit-line.svg": 745574,
	"./RemixIcon/Design/eraser-fill.svg": 953599,
	"./RemixIcon/Design/eraser-line.svg": 54362,
	"./RemixIcon/Design/focus-2-fill.svg": 966390,
	"./RemixIcon/Design/focus-2-line.svg": 123275,
	"./RemixIcon/Design/focus-3-fill.svg": 635313,
	"./RemixIcon/Design/focus-3-line.svg": 828980,
	"./RemixIcon/Design/focus-fill.svg": 624033,
	"./RemixIcon/Design/focus-line.svg": 94372,
	"./RemixIcon/Design/grid-fill.svg": 905571,
	"./RemixIcon/Design/grid-line.svg": 580478,
	"./RemixIcon/Design/hammer-fill.svg": 225925,
	"./RemixIcon/Design/hammer-line.svg": 618312,
	"./RemixIcon/Design/ink-bottle-fill.svg": 587592,
	"./RemixIcon/Design/ink-bottle-line.svg": 928853,
	"./RemixIcon/Design/input-method-fill.svg": 440909,
	"./RemixIcon/Design/input-method-line.svg": 256272,
	"./RemixIcon/Design/layout-2-fill.svg": 766114,
	"./RemixIcon/Design/layout-2-line.svg": 461879,
	"./RemixIcon/Design/layout-3-fill.svg": 311917,
	"./RemixIcon/Design/layout-3-line.svg": 515632,
	"./RemixIcon/Design/layout-4-fill.svg": 427416,
	"./RemixIcon/Design/layout-4-line.svg": 194149,
	"./RemixIcon/Design/layout-5-fill.svg": 490459,
	"./RemixIcon/Design/layout-5-line.svg": 192342,
	"./RemixIcon/Design/layout-6-fill.svg": 618454,
	"./RemixIcon/Design/layout-6-line.svg": 481835,
	"./RemixIcon/Design/layout-bottom-2-fill.svg": 92760,
	"./RemixIcon/Design/layout-bottom-2-line.svg": 859493,
	"./RemixIcon/Design/layout-bottom-fill.svg": 37391,
	"./RemixIcon/Design/layout-bottom-line.svg": 705642,
	"./RemixIcon/Design/layout-column-fill.svg": 242,
	"./RemixIcon/Design/layout-column-line.svg": 395335,
	"./RemixIcon/Design/layout-fill.svg": 808933,
	"./RemixIcon/Design/layout-grid-fill.svg": 913952,
	"./RemixIcon/Design/layout-grid-line.svg": 554189,
	"./RemixIcon/Design/layout-left-2-fill.svg": 64454,
	"./RemixIcon/Design/layout-left-2-line.svg": 359579,
	"./RemixIcon/Design/layout-left-fill.svg": 581073,
	"./RemixIcon/Design/layout-left-line.svg": 870484,
	"./RemixIcon/Design/layout-line.svg": 320168,
	"./RemixIcon/Design/layout-masonry-fill.svg": 833987,
	"./RemixIcon/Design/layout-masonry-line.svg": 325854,
	"./RemixIcon/Design/layout-right-2-fill.svg": 240401,
	"./RemixIcon/Design/layout-right-2-line.svg": 13460,
	"./RemixIcon/Design/layout-right-fill.svg": 482898,
	"./RemixIcon/Design/layout-right-line.svg": 826407,
	"./RemixIcon/Design/layout-row-fill.svg": 132956,
	"./RemixIcon/Design/layout-row-line.svg": 868505,
	"./RemixIcon/Design/layout-top-2-fill.svg": 869884,
	"./RemixIcon/Design/layout-top-2-line.svg": 240057,
	"./RemixIcon/Design/layout-top-fill.svg": 595771,
	"./RemixIcon/Design/layout-top-line.svg": 224502,
	"./RemixIcon/Design/magic-fill.svg": 910738,
	"./RemixIcon/Design/magic-line.svg": 737895,
	"./RemixIcon/Design/mark-pen-fill.svg": 472548,
	"./RemixIcon/Design/mark-pen-line.svg": 458113,
	"./RemixIcon/Design/markup-fill.svg": 279879,
	"./RemixIcon/Design/markup-line.svg": 616482,
	"./RemixIcon/Design/paint-brush-fill.svg": 328716,
	"./RemixIcon/Design/paint-brush-line.svg": 360073,
	"./RemixIcon/Design/paint-fill.svg": 455817,
	"./RemixIcon/Design/paint-line.svg": 466284,
	"./RemixIcon/Design/palette-fill.svg": 140102,
	"./RemixIcon/Design/palette-line.svg": 854363,
	"./RemixIcon/Design/pantone-fill.svg": 757146,
	"./RemixIcon/Design/pantone-line.svg": 405679,
	"./RemixIcon/Design/pen-nib-fill.svg": 261106,
	"./RemixIcon/Design/pen-nib-line.svg": 79495,
	"./RemixIcon/Design/pencil-fill.svg": 641882,
	"./RemixIcon/Design/pencil-line.svg": 569135,
	"./RemixIcon/Design/pencil-ruler-2-fill.svg": 991584,
	"./RemixIcon/Design/pencil-ruler-2-line.svg": 115469,
	"./RemixIcon/Design/pencil-ruler-fill.svg": 784359,
	"./RemixIcon/Design/pencil-ruler-line.svg": 79490,
	"./RemixIcon/Design/quill-pen-fill.svg": 211642,
	"./RemixIcon/Design/quill-pen-line.svg": 564495,
	"./RemixIcon/Design/ruler-2-fill.svg": 847990,
	"./RemixIcon/Design/ruler-2-line.svg": 488523,
	"./RemixIcon/Design/ruler-fill.svg": 43489,
	"./RemixIcon/Design/ruler-line.svg": 30180,
	"./RemixIcon/Design/scissors-2-fill.svg": 202763,
	"./RemixIcon/Design/scissors-2-line.svg": 995910,
	"./RemixIcon/Design/scissors-cut-fill.svg": 724989,
	"./RemixIcon/Design/scissors-cut-line.svg": 29248,
	"./RemixIcon/Design/scissors-fill.svg": 831856,
	"./RemixIcon/Design/scissors-line.svg": 909661,
	"./RemixIcon/Design/screenshot-2-fill.svg": 650044,
	"./RemixIcon/Design/screenshot-2-line.svg": 879545,
	"./RemixIcon/Design/screenshot-fill.svg": 801275,
	"./RemixIcon/Design/screenshot-line.svg": 52726,
	"./RemixIcon/Design/shape-2-fill.svg": 585587,
	"./RemixIcon/Design/shape-2-line.svg": 502030,
	"./RemixIcon/Design/shape-fill.svg": 823272,
	"./RemixIcon/Design/shape-line.svg": 785269,
	"./RemixIcon/Design/sip-fill.svg": 819609,
	"./RemixIcon/Design/sip-line.svg": 924732,
	"./RemixIcon/Design/slice-fill.svg": 547979,
	"./RemixIcon/Design/slice-line.svg": 276614,
	"./RemixIcon/Design/t-box-fill.svg": 366237,
	"./RemixIcon/Design/t-box-line.svg": 38880,
	"./RemixIcon/Design/table-alt-fill.svg": 587039,
	"./RemixIcon/Design/table-alt-line.svg": 394106,
	"./RemixIcon/Design/table-fill.svg": 245717,
	"./RemixIcon/Design/table-line.svg": 208024,
	"./RemixIcon/Design/tools-fill.svg": 33986,
	"./RemixIcon/Design/tools-line.svg": 194583,
	"./RemixIcon/Development/braces-fill.svg": 146398,
	"./RemixIcon/Development/braces-line.svg": 683603,
	"./RemixIcon/Development/brackets-fill.svg": 546767,
	"./RemixIcon/Development/brackets-line.svg": 731370,
	"./RemixIcon/Development/bug-2-fill.svg": 324199,
	"./RemixIcon/Development/bug-2-line.svg": 342914,
	"./RemixIcon/Development/bug-fill.svg": 426916,
	"./RemixIcon/Development/bug-line.svg": 838081,
	"./RemixIcon/Development/code-box-fill.svg": 399443,
	"./RemixIcon/Development/code-box-line.svg": 65134,
	"./RemixIcon/Development/code-fill.svg": 772095,
	"./RemixIcon/Development/code-line.svg": 298842,
	"./RemixIcon/Development/code-s-fill.svg": 832235,
	"./RemixIcon/Development/code-s-line.svg": 446374,
	"./RemixIcon/Development/code-s-slash-fill.svg": 446223,
	"./RemixIcon/Development/code-s-slash-line.svg": 104554,
	"./RemixIcon/Development/command-fill.svg": 2547,
	"./RemixIcon/Development/command-line.svg": 918990,
	"./RemixIcon/Development/css3-fill.svg": 156866,
	"./RemixIcon/Development/css3-line.svg": 648087,
	"./RemixIcon/Development/cursor-fill.svg": 751636,
	"./RemixIcon/Development/cursor-line.svg": 469745,
	"./RemixIcon/Development/git-branch-fill.svg": 335461,
	"./RemixIcon/Development/git-branch-line.svg": 228072,
	"./RemixIcon/Development/git-commit-fill.svg": 978288,
	"./RemixIcon/Development/git-commit-line.svg": 56093,
	"./RemixIcon/Development/git-merge-fill.svg": 753279,
	"./RemixIcon/Development/git-merge-line.svg": 280026,
	"./RemixIcon/Development/git-pull-request-fill.svg": 878758,
	"./RemixIcon/Development/git-pull-request-line.svg": 557051,
	"./RemixIcon/Development/git-repository-commits-fill.svg": 173546,
	"./RemixIcon/Development/git-repository-commits-line.svg": 6655,
	"./RemixIcon/Development/git-repository-fill.svg": 894729,
	"./RemixIcon/Development/git-repository-line.svg": 905196,
	"./RemixIcon/Development/git-repository-private-fill.svg": 90691,
	"./RemixIcon/Development/git-repository-private-line.svg": 387550,
	"./RemixIcon/Development/html5-fill.svg": 302982,
	"./RemixIcon/Development/html5-line.svg": 17243,
	"./RemixIcon/Development/parentheses-fill.svg": 768118,
	"./RemixIcon/Development/parentheses-line.svg": 805771,
	"./RemixIcon/Development/terminal-box-fill.svg": 775270,
	"./RemixIcon/Development/terminal-box-line.svg": 453563,
	"./RemixIcon/Development/terminal-fill.svg": 818894,
	"./RemixIcon/Development/terminal-line.svg": 76675,
	"./RemixIcon/Development/terminal-window-fill.svg": 618573,
	"./RemixIcon/Development/terminal-window-line.svg": 39120,
	"./RemixIcon/Device/airplay-fill.svg": 818735,
	"./RemixIcon/Device/airplay-line.svg": 486282,
	"./RemixIcon/Device/barcode-box-fill.svg": 786633,
	"./RemixIcon/Device/barcode-box-line.svg": 797100,
	"./RemixIcon/Device/barcode-fill.svg": 684157,
	"./RemixIcon/Device/barcode-line.svg": 305216,
	"./RemixIcon/Device/base-station-fill.svg": 797847,
	"./RemixIcon/Device/base-station-line.svg": 416434,
	"./RemixIcon/Device/battery-2-charge-fill.svg": 849390,
	"./RemixIcon/Device/battery-2-charge-line.svg": 473251,
	"./RemixIcon/Device/battery-2-fill.svg": 886475,
	"./RemixIcon/Device/battery-2-line.svg": 98758,
	"./RemixIcon/Device/battery-charge-fill.svg": 529503,
	"./RemixIcon/Device/battery-charge-line.svg": 336570,
	"./RemixIcon/Device/battery-fill.svg": 346224,
	"./RemixIcon/Device/battery-line.svg": 772573,
	"./RemixIcon/Device/battery-low-fill.svg": 843023,
	"./RemixIcon/Device/battery-low-line.svg": 17706,
	"./RemixIcon/Device/battery-saver-fill.svg": 247708,
	"./RemixIcon/Device/battery-saver-line.svg": 983257,
	"./RemixIcon/Device/battery-share-fill.svg": 957466,
	"./RemixIcon/Device/battery-share-line.svg": 89647,
	"./RemixIcon/Device/bluetooth-connect-fill.svg": 555912,
	"./RemixIcon/Device/bluetooth-connect-line.svg": 897173,
	"./RemixIcon/Device/bluetooth-fill.svg": 213991,
	"./RemixIcon/Device/bluetooth-line.svg": 232706,
	"./RemixIcon/Device/cast-fill.svg": 465464,
	"./RemixIcon/Device/cast-line.svg": 509957,
	"./RemixIcon/Device/cellphone-fill.svg": 408189,
	"./RemixIcon/Device/cellphone-line.svg": 806867,
	"./RemixIcon/Device/computer-fill.svg": 781206,
	"./RemixIcon/Device/computer-line.svg": 160939,
	"./RemixIcon/Device/cpu-fill.svg": 346219,
	"./RemixIcon/Device/cpu-line.svg": 960358,
	"./RemixIcon/Device/dashboard-2-fill.svg": 657198,
	"./RemixIcon/Device/dashboard-2-line.svg": 797411,
	"./RemixIcon/Device/dashboard-3-fill.svg": 528361,
	"./RemixIcon/Device/dashboard-3-line.svg": 804940,
	"./RemixIcon/Device/database-2-fill.svg": 417693,
	"./RemixIcon/Device/database-2-line.svg": 90336,
	"./RemixIcon/Device/database-fill.svg": 553622,
	"./RemixIcon/Device/database-line.svg": 356651,
	"./RemixIcon/Device/device-fill.svg": 285089,
	"./RemixIcon/Device/device-line.svg": 552484,
	"./RemixIcon/Device/device-recover-fill.svg": 119624,
	"./RemixIcon/Device/device-recover-line.svg": 884181,
	"./RemixIcon/Device/dual-sim-1-fill.svg": 57905,
	"./RemixIcon/Device/dual-sim-1-line.svg": 735220,
	"./RemixIcon/Device/dual-sim-2-fill.svg": 128888,
	"./RemixIcon/Device/dual-sim-2-line.svg": 173381,
	"./RemixIcon/Device/fingerprint-2-fill.svg": 425974,
	"./RemixIcon/Device/fingerprint-2-line.svg": 66507,
	"./RemixIcon/Device/fingerprint-fill.svg": 894881,
	"./RemixIcon/Device/fingerprint-line.svg": 365220,
	"./RemixIcon/Device/gamepad-fill.svg": 955206,
	"./RemixIcon/Device/gamepad-line.svg": 185819,
	"./RemixIcon/Device/gps-fill.svg": 655265,
	"./RemixIcon/Device/gps-line.svg": 406308,
	"./RemixIcon/Device/gradienter-fill.svg": 824168,
	"./RemixIcon/Device/gradienter-line.svg": 786165,
	"./RemixIcon/Device/hard-drive-2-fill.svg": 841268,
	"./RemixIcon/Device/hard-drive-2-line.svg": 301265,
	"./RemixIcon/Device/hard-drive-fill.svg": 412611,
	"./RemixIcon/Device/hard-drive-line.svg": 904478,
	"./RemixIcon/Device/hotspot-fill.svg": 652226,
	"./RemixIcon/Device/hotspot-line.svg": 143447,
	"./RemixIcon/Device/install-fill.svg": 751214,
	"./RemixIcon/Device/install-line.svg": 647651,
	"./RemixIcon/Device/keyboard-box-fill.svg": 358034,
	"./RemixIcon/Device/keyboard-box-line.svg": 854567,
	"./RemixIcon/Device/keyboard-fill.svg": 651258,
	"./RemixIcon/Device/keyboard-line.svg": 4111,
	"./RemixIcon/Device/mac-fill.svg": 771742,
	"./RemixIcon/Device/mac-line.svg": 591955,
	"./RemixIcon/Device/macbook-fill.svg": 319127,
	"./RemixIcon/Device/macbook-line.svg": 421362,
	"./RemixIcon/Device/mouse-fill.svg": 109866,
	"./RemixIcon/Device/mouse-line.svg": 436543,
	"./RemixIcon/Device/phone-fill.svg": 554229,
	"./RemixIcon/Device/phone-find-fill.svg": 980971,
	"./RemixIcon/Device/phone-find-line.svg": 774118,
	"./RemixIcon/Device/phone-line.svg": 939512,
	"./RemixIcon/Device/phone-lock-fill.svg": 284179,
	"./RemixIcon/Device/phone-lock-line.svg": 949870,
	"./RemixIcon/Device/qr-code-fill.svg": 846538,
	"./RemixIcon/Device/qr-code-line.svg": 441119,
	"./RemixIcon/Device/qr-scan-2-fill.svg": 931930,
	"./RemixIcon/Device/qr-scan-2-line.svg": 76208,
	"./RemixIcon/Device/qr-scan-fill.svg": 35142,
	"./RemixIcon/Device/qr-scan-line.svg": 330267,
	"./RemixIcon/Device/radar-fill.svg": 624521,
	"./RemixIcon/Device/radar-line.svg": 634988,
	"./RemixIcon/Device/remote-control-2-fill.svg": 138314,
	"./RemixIcon/Device/remote-control-2-line.svg": 732895,
	"./RemixIcon/Device/remote-control-fill.svg": 353373,
	"./RemixIcon/Device/remote-control-line.svg": 26016,
	"./RemixIcon/Device/restart-fill.svg": 591610,
	"./RemixIcon/Device/restart-line.svg": 944463,
	"./RemixIcon/Device/rotate-lock-fill.svg": 623484,
	"./RemixIcon/Device/rotate-lock-line.svg": 477305,
	"./RemixIcon/Device/router-fill.svg": 835490,
	"./RemixIcon/Device/router-line.svg": 278711,
	"./RemixIcon/Device/rss-fill.svg": 219401,
	"./RemixIcon/Device/rss-line.svg": 433196,
	"./RemixIcon/Device/save-2-fill.svg": 423221,
	"./RemixIcon/Device/save-2-line.svg": 808504,
	"./RemixIcon/Device/save-3-fill.svg": 999978,
	"./RemixIcon/Device/save-3-line.svg": 326655,
	"./RemixIcon/Device/save-fill.svg": 206366,
	"./RemixIcon/Device/save-line.svg": 26579,
	"./RemixIcon/Device/scan-2-fill.svg": 115517,
	"./RemixIcon/Device/scan-2-line.svg": 419776,
	"./RemixIcon/Device/scan-fill.svg": 268470,
	"./RemixIcon/Device/scan-line.svg": 306123,
	"./RemixIcon/Device/sd-card-fill.svg": 24333,
	"./RemixIcon/Device/sd-card-line.svg": 961232,
	"./RemixIcon/Device/sd-card-mini-fill.svg": 259227,
	"./RemixIcon/Device/sd-card-mini-line.svg": 961110,
	"./RemixIcon/Device/sensor-fill.svg": 641057,
	"./RemixIcon/Device/sensor-line.svg": 392100,
	"./RemixIcon/Device/server-fill.svg": 637684,
	"./RemixIcon/Device/server-line.svg": 614033,
	"./RemixIcon/Device/shut-down-fill.svg": 519744,
	"./RemixIcon/Device/shut-down-line.svg": 456045,
	"./RemixIcon/Device/signal-wifi-1-fill.svg": 400093,
	"./RemixIcon/Device/signal-wifi-1-line.svg": 912864,
	"./RemixIcon/Device/signal-wifi-2-fill.svg": 225908,
	"./RemixIcon/Device/signal-wifi-2-line.svg": 685905,
	"./RemixIcon/Device/signal-wifi-3-fill.svg": 961543,
	"./RemixIcon/Device/signal-wifi-3-line.svg": 335842,
	"./RemixIcon/Device/signal-wifi-error-fill.svg": 564,
	"./RemixIcon/Device/signal-wifi-error-line.svg": 460561,
	"./RemixIcon/Device/signal-wifi-fill.svg": 18243,
	"./RemixIcon/Device/signal-wifi-line.svg": 510110,
	"./RemixIcon/Device/signal-wifi-off-fill.svg": 178635,
	"./RemixIcon/Device/signal-wifi-off-line.svg": 971782,
	"./RemixIcon/Device/sim-card-2-fill.svg": 557608,
	"./RemixIcon/Device/sim-card-2-line.svg": 400757,
	"./RemixIcon/Device/sim-card-fill.svg": 166719,
	"./RemixIcon/Device/sim-card-line.svg": 783834,
	"./RemixIcon/Device/smartphone-fill.svg": 510084,
	"./RemixIcon/Device/smartphone-line.svg": 198049,
	"./RemixIcon/Device/tablet-fill.svg": 701987,
	"./RemixIcon/Device/tablet-line.svg": 540670,
	"./RemixIcon/Device/tv-2-fill.svg": 525650,
	"./RemixIcon/Device/tv-2-line.svg": 22183,
	"./RemixIcon/Device/tv-fill.svg": 829941,
	"./RemixIcon/Device/tv-line.svg": 604856,
	"./RemixIcon/Device/u-disk-fill.svg": 358640,
	"./RemixIcon/Device/u-disk-line.svg": 784989,
	"./RemixIcon/Device/uninstall-fill.svg": 791427,
	"./RemixIcon/Device/uninstall-line.svg": 766942,
	"./RemixIcon/Device/usb-fill.svg": 611315,
	"./RemixIcon/Device/usb-line.svg": 527758,
	"./RemixIcon/Device/wifi-fill.svg": 937758,
	"./RemixIcon/Device/wifi-line.svg": 757971,
	"./RemixIcon/Device/wifi-off-fill.svg": 898874,
	"./RemixIcon/Device/wifi-off-line.svg": 251727,
	"./RemixIcon/Device/wireless-charging-fill.svg": 969809,
	"./RemixIcon/Device/wireless-charging-line.svg": 855572,
	"./RemixIcon/Document/article-fill.svg": 872960,
	"./RemixIcon/Document/article-line.svg": 809261,
	"./RemixIcon/Document/bill-fill.svg": 77571,
	"./RemixIcon/Document/bill-line.svg": 53086,
	"./RemixIcon/Document/book-2-fill.svg": 167164,
	"./RemixIcon/Document/book-2-line.svg": 20985,
	"./RemixIcon/Document/book-3-fill.svg": 452815,
	"./RemixIcon/Document/book-3-line.svg": 637418,
	"./RemixIcon/Document/book-fill.svg": 994043,
	"./RemixIcon/Document/book-line.svg": 622774,
	"./RemixIcon/Document/book-mark-fill.svg": 159927,
	"./RemixIcon/Document/book-mark-line.svg": 926674,
	"./RemixIcon/Document/book-open-fill.svg": 926530,
	"./RemixIcon/Document/book-open-line.svg": 87127,
	"./RemixIcon/Document/book-read-fill.svg": 306038,
	"./RemixIcon/Document/book-read-line.svg": 462923,
	"./RemixIcon/Document/booklet-fill.svg": 693552,
	"./RemixIcon/Document/booklet-line.svg": 119901,
	"./RemixIcon/Document/clipboard-fill.svg": 616988,
	"./RemixIcon/Document/clipboard-line.svg": 352537,
	"./RemixIcon/Document/contacts-book-2-fill.svg": 652588,
	"./RemixIcon/Document/contacts-book-2-line.svg": 855209,
	"./RemixIcon/Document/contacts-book-fill.svg": 772491,
	"./RemixIcon/Document/contacts-book-line.svg": 501126,
	"./RemixIcon/Document/contacts-book-upload-fill.svg": 906999,
	"./RemixIcon/Document/contacts-book-upload-line.svg": 605650,
	"./RemixIcon/Document/draft-fill.svg": 713405,
	"./RemixIcon/Document/draft-line.svg": 17664,
	"./RemixIcon/Document/file-2-fill.svg": 677511,
	"./RemixIcon/Document/file-2-line.svg": 14114,
	"./RemixIcon/Document/file-3-fill.svg": 443956,
	"./RemixIcon/Document/file-3-line.svg": 628305,
	"./RemixIcon/Document/file-4-fill.svg": 839745,
	"./RemixIcon/Document/file-4-line.svg": 687044,
	"./RemixIcon/Document/file-add-fill.svg": 162282,
	"./RemixIcon/Document/file-add-line.svg": 5311,
	"./RemixIcon/Document/file-chart-2-fill.svg": 238542,
	"./RemixIcon/Document/file-chart-2-line.svg": 496323,
	"./RemixIcon/Document/file-chart-fill.svg": 728169,
	"./RemixIcon/Document/file-chart-line.svg": 4748,
	"./RemixIcon/Document/file-cloud-fill.svg": 641624,
	"./RemixIcon/Document/file-cloud-line.svg": 188133,
	"./RemixIcon/Document/file-code-fill.svg": 900474,
	"./RemixIcon/Document/file-code-line.svg": 639055,
	"./RemixIcon/Document/file-copy-2-fill.svg": 542841,
	"./RemixIcon/Document/file-copy-2-line.svg": 699548,
	"./RemixIcon/Document/file-copy-fill.svg": 699626,
	"./RemixIcon/Document/file-copy-line.svg": 542655,
	"./RemixIcon/Document/file-damage-fill.svg": 890806,
	"./RemixIcon/Document/file-damage-line.svg": 531339,
	"./RemixIcon/Document/file-download-fill.svg": 540547,
	"./RemixIcon/Document/file-download-line.svg": 353758,
	"./RemixIcon/Document/file-edit-fill.svg": 544011,
	"./RemixIcon/Document/file-edit-line.svg": 272646,
	"./RemixIcon/Document/file-excel-2-fill.svg": 536973,
	"./RemixIcon/Document/file-excel-2-line.svg": 957520,
	"./RemixIcon/Document/file-excel-fill.svg": 327654,
	"./RemixIcon/Document/file-excel-line.svg": 5947,
	"./RemixIcon/Document/file-fill.svg": 697796,
	"./RemixIcon/Document/file-forbid-fill.svg": 305249,
	"./RemixIcon/Document/file-forbid-line.svg": 291940,
	"./RemixIcon/Document/file-gif-fill.svg": 490251,
	"./RemixIcon/Document/file-gif-line.svg": 702534,
	"./RemixIcon/Document/file-history-fill.svg": 952893,
	"./RemixIcon/Document/file-history-line.svg": 573952,
	"./RemixIcon/Document/file-hwp-fill.svg": 443878,
	"./RemixIcon/Document/file-hwp-line.svg": 122171,
	"./RemixIcon/Document/file-info-fill.svg": 563063,
	"./RemixIcon/Document/file-info-line.svg": 261714,
	"./RemixIcon/Document/file-line.svg": 385761,
	"./RemixIcon/Document/file-list-2-fill.svg": 317748,
	"./RemixIcon/Document/file-list-2-line.svg": 777745,
	"./RemixIcon/Document/file-list-3-fill.svg": 53383,
	"./RemixIcon/Document/file-list-3-line.svg": 427682,
	"./RemixIcon/Document/file-list-fill.svg": 881027,
	"./RemixIcon/Document/file-list-line.svg": 856542,
	"./RemixIcon/Document/file-lock-fill.svg": 973660,
	"./RemixIcon/Document/file-lock-line.svg": 332377,
	"./RemixIcon/Document/file-mark-fill.svg": 561246,
	"./RemixIcon/Document/file-mark-line.svg": 381459,
	"./RemixIcon/Document/file-music-fill.svg": 579290,
	"./RemixIcon/Document/file-music-line.svg": 227823,
	"./RemixIcon/Document/file-paper-2-fill.svg": 447532,
	"./RemixIcon/Document/file-paper-2-line.svg": 650153,
	"./RemixIcon/Document/file-paper-fill.svg": 749003,
	"./RemixIcon/Document/file-paper-line.svg": 961286,
	"./RemixIcon/Document/file-pdf-fill.svg": 582519,
	"./RemixIcon/Document/file-pdf-line.svg": 349266,
	"./RemixIcon/Document/file-ppt-2-fill.svg": 130574,
	"./RemixIcon/Document/file-ppt-2-line.svg": 409155,
	"./RemixIcon/Document/file-ppt-fill.svg": 86953,
	"./RemixIcon/Document/file-ppt-line.svg": 864716,
	"./RemixIcon/Document/file-reduce-fill.svg": 814269,
	"./RemixIcon/Document/file-reduce-line.svg": 435328,
	"./RemixIcon/Document/file-search-fill.svg": 376643,
	"./RemixIcon/Document/file-search-line.svg": 673502,
	"./RemixIcon/Document/file-settings-fill.svg": 439142,
	"./RemixIcon/Document/file-settings-line.svg": 117435,
	"./RemixIcon/Document/file-shield-2-fill.svg": 215333,
	"./RemixIcon/Document/file-shield-2-line.svg": 242920,
	"./RemixIcon/Document/file-shield-fill.svg": 628590,
	"./RemixIcon/Document/file-shield-line.svg": 252451,
	"./RemixIcon/Document/file-shred-fill.svg": 77095,
	"./RemixIcon/Document/file-shred-line.svg": 372226,
	"./RemixIcon/Document/file-text-fill.svg": 543448,
	"./RemixIcon/Document/file-text-line.svg": 826533,
	"./RemixIcon/Document/file-transfer-fill.svg": 39064,
	"./RemixIcon/Document/file-transfer-line.svg": 585573,
	"./RemixIcon/Document/file-unknow-fill.svg": 109887,
	"./RemixIcon/Document/file-unknow-line.svg": 210650,
	"./RemixIcon/Document/file-upload-fill.svg": 617258,
	"./RemixIcon/Document/file-upload-line.svg": 450367,
	"./RemixIcon/Document/file-user-fill.svg": 514892,
	"./RemixIcon/Document/file-user-line.svg": 546249,
	"./RemixIcon/Document/file-warning-fill.svg": 334589,
	"./RemixIcon/Document/file-warning-line.svg": 122496,
	"./RemixIcon/Document/file-word-2-fill.svg": 747384,
	"./RemixIcon/Document/file-word-2-line.svg": 791877,
	"./RemixIcon/Document/file-word-fill.svg": 382319,
	"./RemixIcon/Document/file-word-line.svg": 753866,
	"./RemixIcon/Document/file-zip-fill.svg": 517002,
	"./RemixIcon/Document/file-zip-line.svg": 111583,
	"./RemixIcon/Document/folder-2-fill.svg": 369285,
	"./RemixIcon/Document/folder-2-line.svg": 587976,
	"./RemixIcon/Document/folder-3-fill.svg": 753850,
	"./RemixIcon/Document/folder-3-line.svg": 492431,
	"./RemixIcon/Document/folder-4-fill.svg": 847731,
	"./RemixIcon/Document/folder-4-line.svg": 280526,
	"./RemixIcon/Document/folder-5-fill.svg": 281840,
	"./RemixIcon/Document/folder-5-line.svg": 191837,
	"./RemixIcon/Document/folder-add-fill.svg": 967084,
	"./RemixIcon/Document/folder-add-line.svg": 169705,
	"./RemixIcon/Document/folder-chart-2-fill.svg": 381020,
	"./RemixIcon/Document/folder-chart-2-line.svg": 739737,
	"./RemixIcon/Document/folder-chart-fill.svg": 310747,
	"./RemixIcon/Document/folder-chart-line.svg": 12630,
	"./RemixIcon/Document/folder-download-fill.svg": 630753,
	"./RemixIcon/Document/folder-download-line.svg": 381796,
	"./RemixIcon/Document/folder-fill.svg": 734030,
	"./RemixIcon/Document/folder-forbid-fill.svg": 59735,
	"./RemixIcon/Document/folder-forbid-line.svg": 516850,
	"./RemixIcon/Document/folder-history-fill.svg": 611627,
	"./RemixIcon/Document/folder-history-line.svg": 921126,
	"./RemixIcon/Document/folder-info-fill.svg": 529825,
	"./RemixIcon/Document/folder-info-line.svg": 164,
	"./RemixIcon/Document/folder-keyhole-fill.svg": 112474,
	"./RemixIcon/Document/folder-keyhole-line.svg": 761007,
	"./RemixIcon/Document/folder-line.svg": 991811,
	"./RemixIcon/Document/folder-lock-fill.svg": 127102,
	"./RemixIcon/Document/folder-lock-line.svg": 27699,
	"./RemixIcon/Document/folder-music-fill.svg": 329364,
	"./RemixIcon/Document/folder-music-line.svg": 814769,
	"./RemixIcon/Document/folder-open-fill.svg": 69449,
	"./RemixIcon/Document/folder-open-line.svg": 79916,
	"./RemixIcon/Document/folder-received-fill.svg": 524046,
	"./RemixIcon/Document/folder-received-line.svg": 265475,
	"./RemixIcon/Document/folder-reduce-fill.svg": 961923,
	"./RemixIcon/Document/folder-reduce-line.svg": 453790,
	"./RemixIcon/Document/folder-settings-fill.svg": 125540,
	"./RemixIcon/Document/folder-settings-line.svg": 536705,
	"./RemixIcon/Document/folder-shared-fill.svg": 599736,
	"./RemixIcon/Document/folder-shared-line.svg": 763461,
	"./RemixIcon/Document/folder-shield-2-fill.svg": 521747,
	"./RemixIcon/Document/folder-shield-2-line.svg": 187310,
	"./RemixIcon/Document/folder-shield-fill.svg": 963912,
	"./RemixIcon/Document/folder-shield-line.svg": 305173,
	"./RemixIcon/Document/folder-transfer-fill.svg": 333186,
	"./RemixIcon/Document/folder-transfer-line.svg": 824407,
	"./RemixIcon/Document/folder-unknow-fill.svg": 31161,
	"./RemixIcon/Document/folder-unknow-line.svg": 187868,
	"./RemixIcon/Document/folder-upload-fill.svg": 29660,
	"./RemixIcon/Document/folder-upload-line.svg": 765209,
	"./RemixIcon/Document/folder-user-fill.svg": 186314,
	"./RemixIcon/Document/folder-user-line.svg": 252191,
	"./RemixIcon/Document/folder-warning-fill.svg": 592899,
	"./RemixIcon/Document/folder-warning-line.svg": 84766,
	"./RemixIcon/Document/folder-zip-fill.svg": 679264,
	"./RemixIcon/Document/folder-zip-line.svg": 803149,
	"./RemixIcon/Document/folders-fill.svg": 57867,
	"./RemixIcon/Document/folders-line.svg": 851014,
	"./RemixIcon/Document/keynote-fill.svg": 89505,
	"./RemixIcon/Document/keynote-line.svg": 840548,
	"./RemixIcon/Document/markdown-fill.svg": 5615,
	"./RemixIcon/Document/markdown-line.svg": 673162,
	"./RemixIcon/Document/newspaper-fill.svg": 566477,
	"./RemixIcon/Document/newspaper-line.svg": 381840,
	"./RemixIcon/Document/numbers-fill.svg": 929124,
	"./RemixIcon/Document/numbers-line.svg": 914689,
	"./RemixIcon/Document/pages-fill.svg": 676026,
	"./RemixIcon/Document/pages-line.svg": 930959,
	"./RemixIcon/Document/sticky-note-2-fill.svg": 996527,
	"./RemixIcon/Document/sticky-note-2-line.svg": 664074,
	"./RemixIcon/Document/sticky-note-fill.svg": 981468,
	"./RemixIcon/Document/sticky-note-line.svg": 717017,
	"./RemixIcon/Document/survey-fill.svg": 372660,
	"./RemixIcon/Document/survey-line.svg": 832657,
	"./RemixIcon/Document/task-fill.svg": 85707,
	"./RemixIcon/Document/task-line.svg": 297990,
	"./RemixIcon/Document/todo-fill.svg": 827050,
	"./RemixIcon/Document/todo-line.svg": 670079,
	"./RemixIcon/Editor/a-b.svg": 803428,
	"./RemixIcon/Editor/align-bottom.svg": 901669,
	"./RemixIcon/Editor/align-center.svg": 736559,
	"./RemixIcon/Editor/align-justify.svg": 756,
	"./RemixIcon/Editor/align-left.svg": 567399,
	"./RemixIcon/Editor/align-right.svg": 506434,
	"./RemixIcon/Editor/align-top.svg": 207117,
	"./RemixIcon/Editor/align-vertically.svg": 178735,
	"./RemixIcon/Editor/asterisk.svg": 284536,
	"./RemixIcon/Editor/attachment-2.svg": 33398,
	"./RemixIcon/Editor/bold.svg": 894917,
	"./RemixIcon/Editor/bring-forward.svg": 606180,
	"./RemixIcon/Editor/bring-to-front.svg": 809568,
	"./RemixIcon/Editor/code-view.svg": 516335,
	"./RemixIcon/Editor/delete-column.svg": 605844,
	"./RemixIcon/Editor/delete-row.svg": 206830,
	"./RemixIcon/Editor/double-quotes-l.svg": 98816,
	"./RemixIcon/Editor/double-quotes-r.svg": 759158,
	"./RemixIcon/Editor/emphasis-cn.svg": 74868,
	"./RemixIcon/Editor/emphasis.svg": 845926,
	"./RemixIcon/Editor/english-input.svg": 1843,
	"./RemixIcon/Editor/flow-chart.svg": 256207,
	"./RemixIcon/Editor/font-color.svg": 119169,
	"./RemixIcon/Editor/font-size-2.svg": 309194,
	"./RemixIcon/Editor/font-size.svg": 674863,
	"./RemixIcon/Editor/format-clear.svg": 50581,
	"./RemixIcon/Editor/functions.svg": 923903,
	"./RemixIcon/Editor/h-1.svg": 25314,
	"./RemixIcon/Editor/h-2.svg": 189361,
	"./RemixIcon/Editor/h-3.svg": 748800,
	"./RemixIcon/Editor/h-4.svg": 61823,
	"./RemixIcon/Editor/h-5.svg": 523886,
	"./RemixIcon/Editor/h-6.svg": 334605,
	"./RemixIcon/Editor/hashtag.svg": 784036,
	"./RemixIcon/Editor/heading.svg": 770558,
	"./RemixIcon/Editor/indent-decrease.svg": 367563,
	"./RemixIcon/Editor/indent-increase.svg": 454295,
	"./RemixIcon/Editor/input-cursor-move.svg": 768639,
	"./RemixIcon/Editor/insert-column-left.svg": 118980,
	"./RemixIcon/Editor/insert-column-right.svg": 15403,
	"./RemixIcon/Editor/insert-row-bottom.svg": 334112,
	"./RemixIcon/Editor/insert-row-top.svg": 933626,
	"./RemixIcon/Editor/italic.svg": 588812,
	"./RemixIcon/Editor/line-height.svg": 624874,
	"./RemixIcon/Editor/link-m.svg": 134566,
	"./RemixIcon/Editor/link-unlink-m.svg": 243390,
	"./RemixIcon/Editor/link-unlink.svg": 815476,
	"./RemixIcon/Editor/link.svg": 550172,
	"./RemixIcon/Editor/list-check-2.svg": 796178,
	"./RemixIcon/Editor/list-check.svg": 648295,
	"./RemixIcon/Editor/list-ordered.svg": 48452,
	"./RemixIcon/Editor/list-unordered.svg": 887183,
	"./RemixIcon/Editor/merge-cells-horizontal.svg": 672989,
	"./RemixIcon/Editor/merge-cells-vertical.svg": 749275,
	"./RemixIcon/Editor/mind-map.svg": 695937,
	"./RemixIcon/Editor/node-tree.svg": 575809,
	"./RemixIcon/Editor/number-0.svg": 110784,
	"./RemixIcon/Editor/number-1.svg": 525169,
	"./RemixIcon/Editor/number-2.svg": 268066,
	"./RemixIcon/Editor/number-3.svg": 671795,
	"./RemixIcon/Editor/number-4.svg": 549228,
	"./RemixIcon/Editor/number-5.svg": 696589,
	"./RemixIcon/Editor/number-6.svg": 613614,
	"./RemixIcon/Editor/number-7.svg": 728255,
	"./RemixIcon/Editor/number-8.svg": 618040,
	"./RemixIcon/Editor/number-9.svg": 543401,
	"./RemixIcon/Editor/omega.svg": 663805,
	"./RemixIcon/Editor/organization-chart.svg": 692898,
	"./RemixIcon/Editor/page-separator.svg": 525563,
	"./RemixIcon/Editor/paragraph.svg": 683494,
	"./RemixIcon/Editor/pinyin-input.svg": 727056,
	"./RemixIcon/Editor/question-mark.svg": 775854,
	"./RemixIcon/Editor/rounded-corner.svg": 35351,
	"./RemixIcon/Editor/send-backward.svg": 950396,
	"./RemixIcon/Editor/send-to-back.svg": 949100,
	"./RemixIcon/Editor/separator.svg": 473473,
	"./RemixIcon/Editor/single-quotes-l.svg": 807117,
	"./RemixIcon/Editor/single-quotes-r.svg": 838779,
	"./RemixIcon/Editor/sort-asc.svg": 223880,
	"./RemixIcon/Editor/sort-desc.svg": 21654,
	"./RemixIcon/Editor/space.svg": 162286,
	"./RemixIcon/Editor/split-cells-horizontal.svg": 442553,
	"./RemixIcon/Editor/split-cells-vertical.svg": 74927,
	"./RemixIcon/Editor/strikethrough-2.svg": 296484,
	"./RemixIcon/Editor/strikethrough.svg": 645237,
	"./RemixIcon/Editor/subscript-2.svg": 86450,
	"./RemixIcon/Editor/subscript.svg": 771783,
	"./RemixIcon/Editor/superscript-2.svg": 103589,
	"./RemixIcon/Editor/superscript.svg": 140872,
	"./RemixIcon/Editor/table-2.svg": 594029,
	"./RemixIcon/Editor/text-direction-l.svg": 308754,
	"./RemixIcon/Editor/text-direction-r.svg": 680292,
	"./RemixIcon/Editor/text-spacing.svg": 374461,
	"./RemixIcon/Editor/text-wrap.svg": 808434,
	"./RemixIcon/Editor/text.svg": 772265,
	"./RemixIcon/Editor/translate-2.svg": 192583,
	"./RemixIcon/Editor/translate.svg": 677038,
	"./RemixIcon/Editor/underline.svg": 223464,
	"./RemixIcon/Editor/wubi-input.svg": 944672,
	"./RemixIcon/Finance/24-hours-fill.svg": 450523,
	"./RemixIcon/Finance/24-hours-line.svg": 152406,
	"./RemixIcon/Finance/auction-fill.svg": 153484,
	"./RemixIcon/Finance/auction-line.svg": 701193,
	"./RemixIcon/Finance/bank-card-2-fill.svg": 908097,
	"./RemixIcon/Finance/bank-card-2-line.svg": 755396,
	"./RemixIcon/Finance/bank-card-fill.svg": 900258,
	"./RemixIcon/Finance/bank-card-line.svg": 79671,
	"./RemixIcon/Finance/bit-coin-fill.svg": 520540,
	"./RemixIcon/Finance/bit-coin-line.svg": 395609,
	"./RemixIcon/Finance/coin-fill.svg": 223490,
	"./RemixIcon/Finance/coin-line.svg": 714711,
	"./RemixIcon/Finance/coins-fill.svg": 162007,
	"./RemixIcon/Finance/coins-line.svg": 780594,
	"./RemixIcon/Finance/copper-coin-fill.svg": 925880,
	"./RemixIcon/Finance/copper-coin-line.svg": 89605,
	"./RemixIcon/Finance/copper-diamond-fill.svg": 477891,
	"./RemixIcon/Finance/copper-diamond-line.svg": 774750,
	"./RemixIcon/Finance/coupon-2-fill.svg": 717126,
	"./RemixIcon/Finance/coupon-2-line.svg": 12251,
	"./RemixIcon/Finance/coupon-3-fill.svg": 54145,
	"./RemixIcon/Finance/coupon-3-line.svg": 230468,
	"./RemixIcon/Finance/coupon-4-fill.svg": 27828,
	"./RemixIcon/Finance/coupon-4-line.svg": 487825,
	"./RemixIcon/Finance/coupon-5-fill.svg": 763463,
	"./RemixIcon/Finance/coupon-5-line.svg": 137762,
	"./RemixIcon/Finance/coupon-fill.svg": 933457,
	"./RemixIcon/Finance/coupon-line.svg": 222868,
	"./RemixIcon/Finance/currency-fill.svg": 75112,
	"./RemixIcon/Finance/currency-line.svg": 918261,
	"./RemixIcon/Finance/exchange-box-fill.svg": 53990,
	"./RemixIcon/Finance/exchange-box-line.svg": 732283,
	"./RemixIcon/Finance/exchange-cny-fill.svg": 300815,
	"./RemixIcon/Finance/exchange-cny-line.svg": 475498,
	"./RemixIcon/Finance/exchange-dollar-fill.svg": 406411,
	"./RemixIcon/Finance/exchange-dollar-line.svg": 199558,
	"./RemixIcon/Finance/exchange-fill.svg": 729870,
	"./RemixIcon/Finance/exchange-funds-fill.svg": 108939,
	"./RemixIcon/Finance/exchange-funds-line.svg": 418438,
	"./RemixIcon/Finance/exchange-line.svg": 987651,
	"./RemixIcon/Finance/funds-box-fill.svg": 123641,
	"./RemixIcon/Finance/funds-box-line.svg": 701340,
	"./RemixIcon/Finance/funds-fill.svg": 302157,
	"./RemixIcon/Finance/funds-line.svg": 239056,
	"./RemixIcon/Finance/gift-2-fill.svg": 784338,
	"./RemixIcon/Finance/gift-2-line.svg": 611495,
	"./RemixIcon/Finance/gift-fill.svg": 898037,
	"./RemixIcon/Finance/gift-line.svg": 283320,
	"./RemixIcon/Finance/hand-coin-fill.svg": 191884,
	"./RemixIcon/Finance/hand-coin-line.svg": 162889,
	"./RemixIcon/Finance/hand-heart-fill.svg": 231591,
	"./RemixIcon/Finance/hand-heart-line.svg": 733954,
	"./RemixIcon/Finance/increase-decrease-fill.svg": 392882,
	"./RemixIcon/Finance/increase-decrease-line.svg": 271623,
	"./RemixIcon/Finance/money-cny-box-fill.svg": 40328,
	"./RemixIcon/Finance/money-cny-box-line.svg": 381589,
	"./RemixIcon/Finance/money-cny-circle-fill.svg": 815335,
	"./RemixIcon/Finance/money-cny-circle-line.svg": 110466,
	"./RemixIcon/Finance/money-dollar-box-fill.svg": 795354,
	"./RemixIcon/Finance/money-dollar-box-line.svg": 722607,
	"./RemixIcon/Finance/money-dollar-circle-fill.svg": 458177,
	"./RemixIcon/Finance/money-dollar-circle-line.svg": 634500,
	"./RemixIcon/Finance/money-euro-box-fill.svg": 224353,
	"./RemixIcon/Finance/money-euro-box-line.svg": 975396,
	"./RemixIcon/Finance/money-euro-circle-fill.svg": 397328,
	"./RemixIcon/Finance/money-euro-circle-line.svg": 777277,
	"./RemixIcon/Finance/money-pound-box-fill.svg": 321522,
	"./RemixIcon/Finance/money-pound-box-line.svg": 139911,
	"./RemixIcon/Finance/money-pound-circle-fill.svg": 457225,
	"./RemixIcon/Finance/money-pound-circle-line.svg": 467692,
	"./RemixIcon/Finance/percent-fill.svg": 167572,
	"./RemixIcon/Finance/percent-line.svg": 652977,
	"./RemixIcon/Finance/price-tag-2-fill.svg": 641494,
	"./RemixIcon/Finance/price-tag-2-line.svg": 444523,
	"./RemixIcon/Finance/price-tag-3-fill.svg": 781329,
	"./RemixIcon/Finance/price-tag-3-line.svg": 667092,
	"./RemixIcon/Finance/price-tag-fill.svg": 405889,
	"./RemixIcon/Finance/price-tag-line.svg": 253188,
	"./RemixIcon/Finance/red-packet-fill.svg": 158805,
	"./RemixIcon/Finance/red-packet-line.svg": 604760,
	"./RemixIcon/Finance/refund-2-fill.svg": 48034,
	"./RemixIcon/Finance/refund-2-line.svg": 7607,
	"./RemixIcon/Finance/refund-fill.svg": 369701,
	"./RemixIcon/Finance/refund-line.svg": 745960,
	"./RemixIcon/Finance/safe-2-fill.svg": 261757,
	"./RemixIcon/Finance/safe-2-line.svg": 566016,
	"./RemixIcon/Finance/safe-fill.svg": 877366,
	"./RemixIcon/Finance/safe-line.svg": 915019,
	"./RemixIcon/Finance/secure-payment-fill.svg": 490169,
	"./RemixIcon/Finance/secure-payment-line.svg": 646876,
	"./RemixIcon/Finance/shopping-bag-2-fill.svg": 640211,
	"./RemixIcon/Finance/shopping-bag-2-line.svg": 305902,
	"./RemixIcon/Finance/shopping-bag-3-fill.svg": 514768,
	"./RemixIcon/Finance/shopping-bag-3-line.svg": 894717,
	"./RemixIcon/Finance/shopping-bag-fill.svg": 440200,
	"./RemixIcon/Finance/shopping-bag-line.svg": 204757,
	"./RemixIcon/Finance/shopping-basket-2-fill.svg": 407207,
	"./RemixIcon/Finance/shopping-basket-2-line.svg": 425922,
	"./RemixIcon/Finance/shopping-basket-fill.svg": 599780,
	"./RemixIcon/Finance/shopping-basket-line.svg": 494593,
	"./RemixIcon/Finance/shopping-cart-2-fill.svg": 494483,
	"./RemixIcon/Finance/shopping-cart-2-line.svg": 643694,
	"./RemixIcon/Finance/shopping-cart-fill.svg": 698632,
	"./RemixIcon/Finance/shopping-cart-line.svg": 39893,
	"./RemixIcon/Finance/stock-fill.svg": 285183,
	"./RemixIcon/Finance/stock-line.svg": 811930,
	"./RemixIcon/Finance/swap-box-fill.svg": 474744,
	"./RemixIcon/Finance/swap-box-line.svg": 638469,
	"./RemixIcon/Finance/swap-fill.svg": 276784,
	"./RemixIcon/Finance/swap-line.svg": 703133,
	"./RemixIcon/Finance/ticket-2-fill.svg": 514856,
	"./RemixIcon/Finance/ticket-2-line.svg": 358005,
	"./RemixIcon/Finance/ticket-fill.svg": 681663,
	"./RemixIcon/Finance/ticket-line.svg": 782426,
	"./RemixIcon/Finance/trophy-fill.svg": 173997,
	"./RemixIcon/Finance/trophy-line.svg": 540656,
	"./RemixIcon/Finance/vip-crown-2-fill.svg": 674487,
	"./RemixIcon/Finance/vip-crown-2-line.svg": 924882,
	"./RemixIcon/Finance/vip-crown-fill.svg": 493588,
	"./RemixIcon/Finance/vip-crown-line.svg": 211697,
	"./RemixIcon/Finance/vip-diamond-fill.svg": 938087,
	"./RemixIcon/Finance/vip-diamond-line.svg": 956802,
	"./RemixIcon/Finance/vip-fill.svg": 310574,
	"./RemixIcon/Finance/vip-line.svg": 450787,
	"./RemixIcon/Finance/wallet-2-fill.svg": 312105,
	"./RemixIcon/Finance/wallet-2-line.svg": 89868,
	"./RemixIcon/Finance/wallet-3-fill.svg": 892206,
	"./RemixIcon/Finance/wallet-3-line.svg": 272291,
	"./RemixIcon/Finance/wallet-fill.svg": 834298,
	"./RemixIcon/Finance/wallet-line.svg": 572879,
	"./RemixIcon/Finance/water-flash-fill.svg": 85613,
	"./RemixIcon/Finance/water-flash-line.svg": 289328,
	"./RemixIcon/Health/capsule-fill.svg": 263798,
	"./RemixIcon/Health/capsule-line.svg": 420683,
	"./RemixIcon/Health/dislike-fill.svg": 226494,
	"./RemixIcon/Health/dislike-line.svg": 178163,
	"./RemixIcon/Health/dossier-fill.svg": 479056,
	"./RemixIcon/Health/dossier-line.svg": 921661,
	"./RemixIcon/Health/empathize-fill.svg": 320360,
	"./RemixIcon/Health/empathize-line.svg": 163509,
	"./RemixIcon/Health/first-aid-kit-fill.svg": 733105,
	"./RemixIcon/Health/first-aid-kit-line.svg": 287668,
	"./RemixIcon/Health/flask-fill.svg": 36322,
	"./RemixIcon/Health/flask-line.svg": 732087,
	"./RemixIcon/Health/hand-sanitizer-fill.svg": 270820,
	"./RemixIcon/Health/hand-sanitizer-line.svg": 681985,
	"./RemixIcon/Health/health-book-fill.svg": 907285,
	"./RemixIcon/Health/health-book-line.svg": 869592,
	"./RemixIcon/Health/heart-2-fill.svg": 204970,
	"./RemixIcon/Health/heart-2-line.svg": 38079,
	"./RemixIcon/Health/heart-3-fill.svg": 206709,
	"./RemixIcon/Health/heart-3-line.svg": 981624,
	"./RemixIcon/Health/heart-add-fill.svg": 232079,
	"./RemixIcon/Health/heart-add-line.svg": 406762,
	"./RemixIcon/Health/heart-fill.svg": 982013,
	"./RemixIcon/Health/heart-line.svg": 603072,
	"./RemixIcon/Health/heart-pulse-fill.svg": 393301,
	"./RemixIcon/Health/heart-pulse-line.svg": 355608,
	"./RemixIcon/Health/hearts-fill.svg": 373314,
	"./RemixIcon/Health/hearts-line.svg": 380887,
	"./RemixIcon/Health/infrared-thermometer-fill.svg": 518059,
	"./RemixIcon/Health/infrared-thermometer-line.svg": 311206,
	"./RemixIcon/Health/lungs-fill.svg": 350020,
	"./RemixIcon/Health/lungs-line.svg": 37985,
	"./RemixIcon/Health/medicine-bottle-fill.svg": 645538,
	"./RemixIcon/Health/medicine-bottle-line.svg": 605111,
	"./RemixIcon/Health/mental-health-fill.svg": 492775,
	"./RemixIcon/Health/mental-health-line.svg": 787906,
	"./RemixIcon/Health/microscope-fill.svg": 323071,
	"./RemixIcon/Health/microscope-line.svg": 849818,
	"./RemixIcon/Health/nurse-fill.svg": 534560,
	"./RemixIcon/Health/nurse-line.svg": 310925,
	"./RemixIcon/Health/psychotherapy-fill.svg": 73120,
	"./RemixIcon/Health/psychotherapy-line.svg": 849485,
	"./RemixIcon/Health/pulse-fill.svg": 695468,
	"./RemixIcon/Health/pulse-line.svg": 898089,
	"./RemixIcon/Health/rest-time-fill.svg": 966345,
	"./RemixIcon/Health/rest-time-line.svg": 696492,
	"./RemixIcon/Health/stethoscope-fill.svg": 360572,
	"./RemixIcon/Health/stethoscope-line.svg": 730745,
	"./RemixIcon/Health/surgical-mask-fill.svg": 981996,
	"./RemixIcon/Health/surgical-mask-line.svg": 700969,
	"./RemixIcon/Health/syringe-fill.svg": 252436,
	"./RemixIcon/Health/syringe-line.svg": 454193,
	"./RemixIcon/Health/test-tube-fill.svg": 563432,
	"./RemixIcon/Health/test-tube-line.svg": 406581,
	"./RemixIcon/Health/thermometer-fill.svg": 630265,
	"./RemixIcon/Health/thermometer-line.svg": 207964,
	"./RemixIcon/Health/virus-fill.svg": 661292,
	"./RemixIcon/Health/virus-line.svg": 863913,
	"./RemixIcon/Health/zzz-fill.svg": 429667,
	"./RemixIcon/Health/zzz-line.svg": 751998,
	"./RemixIcon/Logos/alipay-fill.svg": 895995,
	"./RemixIcon/Logos/alipay-line.svg": 524726,
	"./RemixIcon/Logos/amazon-fill.svg": 614861,
	"./RemixIcon/Logos/amazon-line.svg": 35408,
	"./RemixIcon/Logos/android-fill.svg": 732356,
	"./RemixIcon/Logos/android-line.svg": 141217,
	"./RemixIcon/Logos/angularjs-fill.svg": 84690,
	"./RemixIcon/Logos/angularjs-line.svg": 428199,
	"./RemixIcon/Logos/app-store-fill.svg": 639412,
	"./RemixIcon/Logos/app-store-line.svg": 99409,
	"./RemixIcon/Logos/apple-fill.svg": 246819,
	"./RemixIcon/Logos/apple-line.svg": 921726,
	"./RemixIcon/Logos/baidu-fill.svg": 659396,
	"./RemixIcon/Logos/baidu-line.svg": 831009,
	"./RemixIcon/Logos/behance-fill.svg": 745403,
	"./RemixIcon/Logos/behance-line.svg": 996854,
	"./RemixIcon/Logos/bilibili-fill.svg": 288385,
	"./RemixIcon/Logos/bilibili-line.svg": 135684,
	"./RemixIcon/Logos/centos-fill.svg": 485685,
	"./RemixIcon/Logos/centos-line.svg": 776952,
	"./RemixIcon/Logos/chrome-fill.svg": 914759,
	"./RemixIcon/Logos/chrome-line.svg": 289058,
	"./RemixIcon/Logos/codepen-fill.svg": 78255,
	"./RemixIcon/Logos/codepen-line.svg": 745802,
	"./RemixIcon/Logos/coreos-fill.svg": 616700,
	"./RemixIcon/Logos/coreos-line.svg": 470521,
	"./RemixIcon/Logos/dingding-fill.svg": 467305,
	"./RemixIcon/Logos/dingding-line.svg": 761420,
	"./RemixIcon/Logos/discord-fill.svg": 800219,
	"./RemixIcon/Logos/discord-line.svg": 502102,
	"./RemixIcon/Logos/disqus-fill.svg": 474438,
	"./RemixIcon/Logos/disqus-line.svg": 188699,
	"./RemixIcon/Logos/douban-fill.svg": 71316,
	"./RemixIcon/Logos/douban-line.svg": 556721,
	"./RemixIcon/Logos/dribbble-fill.svg": 895363,
	"./RemixIcon/Logos/dribbble-line.svg": 708574,
	"./RemixIcon/Logos/drive-fill.svg": 796467,
	"./RemixIcon/Logos/drive-line.svg": 980430,
	"./RemixIcon/Logos/dropbox-fill.svg": 767269,
	"./RemixIcon/Logos/dropbox-line.svg": 278504,
	"./RemixIcon/Logos/edge-fill.svg": 368840,
	"./RemixIcon/Logos/edge-line.svg": 710101,
	"./RemixIcon/Logos/evernote-fill.svg": 174361,
	"./RemixIcon/Logos/evernote-line.svg": 385980,
	"./RemixIcon/Logos/facebook-box-fill.svg": 902025,
	"./RemixIcon/Logos/facebook-box-line.svg": 632172,
	"./RemixIcon/Logos/facebook-circle-fill.svg": 453288,
	"./RemixIcon/Logos/facebook-circle-line.svg": 415285,
	"./RemixIcon/Logos/facebook-fill.svg": 223869,
	"./RemixIcon/Logos/facebook-line.svg": 11776,
	"./RemixIcon/Logos/finder-fill.svg": 685125,
	"./RemixIcon/Logos/finder-line.svg": 903816,
	"./RemixIcon/Logos/firefox-fill.svg": 378442,
	"./RemixIcon/Logos/firefox-line.svg": 973023,
	"./RemixIcon/Logos/flutter-fill.svg": 554201,
	"./RemixIcon/Logos/flutter-line.svg": 659324,
	"./RemixIcon/Logos/gatsby-fill.svg": 765045,
	"./RemixIcon/Logos/gatsby-line.svg": 56312,
	"./RemixIcon/Logos/github-fill.svg": 941166,
	"./RemixIcon/Logos/github-line.svg": 81379,
	"./RemixIcon/Logos/gitlab-fill.svg": 365862,
	"./RemixIcon/Logos/gitlab-line.svg": 44155,
	"./RemixIcon/Logos/google-fill.svg": 649994,
	"./RemixIcon/Logos/google-line.svg": 244575,
	"./RemixIcon/Logos/google-play-fill.svg": 362499,
	"./RemixIcon/Logos/google-play-line.svg": 659358,
	"./RemixIcon/Logos/honor-of-kings-fill.svg": 344954,
	"./RemixIcon/Logos/honor-of-kings-line.svg": 83535,
	"./RemixIcon/Logos/ie-fill.svg": 277395,
	"./RemixIcon/Logos/ie-line.svg": 943086,
	"./RemixIcon/Logos/instagram-fill.svg": 313623,
	"./RemixIcon/Logos/instagram-line.svg": 770738,
	"./RemixIcon/Logos/invision-fill.svg": 395174,
	"./RemixIcon/Logos/invision-line.svg": 73467,
	"./RemixIcon/Logos/kakao-talk-fill.svg": 130499,
	"./RemixIcon/Logos/kakao-talk-line.svg": 622366,
	"./RemixIcon/Logos/line-fill.svg": 407835,
	"./RemixIcon/Logos/line-line.svg": 626070,
	"./RemixIcon/Logos/linkedin-box-fill.svg": 573423,
	"./RemixIcon/Logos/linkedin-box-line.svg": 240970,
	"./RemixIcon/Logos/linkedin-fill.svg": 205211,
	"./RemixIcon/Logos/linkedin-line.svg": 907094,
	"./RemixIcon/Logos/mastercard-fill.svg": 977129,
	"./RemixIcon/Logos/mastercard-line.svg": 271244,
	"./RemixIcon/Logos/mastodon-fill.svg": 179638,
	"./RemixIcon/Logos/mastodon-line.svg": 217291,
	"./RemixIcon/Logos/medium-fill.svg": 365514,
	"./RemixIcon/Logos/medium-line.svg": 960095,
	"./RemixIcon/Logos/messenger-fill.svg": 27076,
	"./RemixIcon/Logos/messenger-line.svg": 435937,
	"./RemixIcon/Logos/microsoft-fill.svg": 391075,
	"./RemixIcon/Logos/microsoft-line.svg": 713406,
	"./RemixIcon/Logos/mini-program-fill.svg": 269791,
	"./RemixIcon/Logos/mini-program-line.svg": 277882,
	"./RemixIcon/Logos/netease-cloud-music-fill.svg": 585220,
	"./RemixIcon/Logos/netease-cloud-music-line.svg": 994081,
	"./RemixIcon/Logos/netflix-fill.svg": 888975,
	"./RemixIcon/Logos/netflix-line.svg": 557226,
	"./RemixIcon/Logos/npmjs-fill.svg": 596357,
	"./RemixIcon/Logos/npmjs-line.svg": 815048,
	"./RemixIcon/Logos/open-source-fill.svg": 128849,
	"./RemixIcon/Logos/open-source-line.svg": 14612,
	"./RemixIcon/Logos/opera-fill.svg": 88000,
	"./RemixIcon/Logos/opera-line.svg": 681325,
	"./RemixIcon/Logos/patreon-fill.svg": 70566,
	"./RemixIcon/Logos/patreon-line.svg": 16379,
	"./RemixIcon/Logos/paypal-fill.svg": 406458,
	"./RemixIcon/Logos/paypal-line.svg": 242959,
	"./RemixIcon/Logos/pinterest-fill.svg": 135149,
	"./RemixIcon/Logos/pinterest-line.svg": 338864,
	"./RemixIcon/Logos/pixelfed-fill.svg": 247082,
	"./RemixIcon/Logos/pixelfed-line.svg": 80191,
	"./RemixIcon/Logos/playstation-fill.svg": 667709,
	"./RemixIcon/Logos/playstation-line.svg": 455616,
	"./RemixIcon/Logos/product-hunt-fill.svg": 323914,
	"./RemixIcon/Logos/product-hunt-line.svg": 402143,
	"./RemixIcon/Logos/qq-fill.svg": 317063,
	"./RemixIcon/Logos/qq-line.svg": 691362,
	"./RemixIcon/Logos/reactjs-fill.svg": 721047,
	"./RemixIcon/Logos/reactjs-line.svg": 178162,
	"./RemixIcon/Logos/reddit-fill.svg": 901245,
	"./RemixIcon/Logos/reddit-line.svg": 522304,
	"./RemixIcon/Logos/remixicon-fill.svg": 207911,
	"./RemixIcon/Logos/remixicon-line.svg": 710274,
	"./RemixIcon/Logos/safari-fill.svg": 633665,
	"./RemixIcon/Logos/safari-line.svg": 326340,
	"./RemixIcon/Logos/skype-fill.svg": 553173,
	"./RemixIcon/Logos/skype-line.svg": 826072,
	"./RemixIcon/Logos/slack-fill.svg": 924239,
	"./RemixIcon/Logos/slack-line.svg": 592490,
	"./RemixIcon/Logos/snapchat-fill.svg": 40687,
	"./RemixIcon/Logos/snapchat-line.svg": 708234,
	"./RemixIcon/Logos/soundcloud-fill.svg": 850885,
	"./RemixIcon/Logos/soundcloud-line.svg": 243272,
	"./RemixIcon/Logos/spectrum-fill.svg": 70722,
	"./RemixIcon/Logos/spectrum-line.svg": 561943,
	"./RemixIcon/Logos/spotify-fill.svg": 283425,
	"./RemixIcon/Logos/spotify-line.svg": 753764,
	"./RemixIcon/Logos/stack-overflow-fill.svg": 628880,
	"./RemixIcon/Logos/stack-overflow-line.svg": 8829,
	"./RemixIcon/Logos/stackshare-fill.svg": 365702,
	"./RemixIcon/Logos/stackshare-line.svg": 596315,
	"./RemixIcon/Logos/steam-fill.svg": 583347,
	"./RemixIcon/Logos/steam-line.svg": 767310,
	"./RemixIcon/Logos/switch-fill.svg": 479721,
	"./RemixIcon/Logos/switch-line.svg": 257484,
	"./RemixIcon/Logos/taobao-fill.svg": 918919,
	"./RemixIcon/Logos/taobao-line.svg": 293218,
	"./RemixIcon/Logos/telegram-fill.svg": 568154,
	"./RemixIcon/Logos/telegram-line.svg": 216687,
	"./RemixIcon/Logos/trello-fill.svg": 264751,
	"./RemixIcon/Logos/trello-line.svg": 636298,
	"./RemixIcon/Logos/tumblr-fill.svg": 896219,
	"./RemixIcon/Logos/tumblr-line.svg": 733398,
	"./RemixIcon/Logos/twitch-fill.svg": 523222,
	"./RemixIcon/Logos/twitch-line.svg": 386603,
	"./RemixIcon/Logos/twitter-fill.svg": 322824,
	"./RemixIcon/Logos/twitter-line.svg": 664085,
	"./RemixIcon/Logos/ubuntu-fill.svg": 780134,
	"./RemixIcon/Logos/ubuntu-line.svg": 458427,
	"./RemixIcon/Logos/unsplash-fill.svg": 825961,
	"./RemixIcon/Logos/unsplash-line.svg": 102540,
	"./RemixIcon/Logos/vimeo-fill.svg": 215455,
	"./RemixIcon/Logos/vimeo-line.svg": 739898,
	"./RemixIcon/Logos/visa-fill.svg": 966840,
	"./RemixIcon/Logos/visa-line.svg": 11333,
	"./RemixIcon/Logos/vuejs-fill.svg": 300064,
	"./RemixIcon/Logos/vuejs-line.svg": 560077,
	"./RemixIcon/Logos/wechat-2-fill.svg": 2392,
	"./RemixIcon/Logos/wechat-2-line.svg": 548901,
	"./RemixIcon/Logos/wechat-fill.svg": 295887,
	"./RemixIcon/Logos/wechat-line.svg": 470570,
	"./RemixIcon/Logos/wechat-pay-fill.svg": 493264,
	"./RemixIcon/Logos/wechat-pay-line.svg": 873213,
	"./RemixIcon/Logos/weibo-fill.svg": 391811,
	"./RemixIcon/Logos/weibo-line.svg": 367326,
	"./RemixIcon/Logos/whatsapp-fill.svg": 33431,
	"./RemixIcon/Logos/whatsapp-line.svg": 974194,
	"./RemixIcon/Logos/windows-fill.svg": 411446,
	"./RemixIcon/Logos/windows-line.svg": 449099,
	"./RemixIcon/Logos/xbox-fill.svg": 184016,
	"./RemixIcon/Logos/xbox-line.svg": 563965,
	"./RemixIcon/Logos/xing-fill.svg": 362621,
	"./RemixIcon/Logos/xing-line.svg": 666880,
	"./RemixIcon/Logos/youtube-fill.svg": 384382,
	"./RemixIcon/Logos/youtube-line.svg": 852403,
	"./RemixIcon/Logos/zcool-fill.svg": 808912,
	"./RemixIcon/Logos/zcool-line.svg": 251517,
	"./RemixIcon/Logos/zhihu-fill.svg": 255845,
	"./RemixIcon/Logos/zhihu-line.svg": 767080,
	"./RemixIcon/Map/anchor-fill.svg": 151562,
	"./RemixIcon/Map/anchor-line.svg": 746143,
	"./RemixIcon/Map/barricade-fill.svg": 412950,
	"./RemixIcon/Map/barricade-line.svg": 792683,
	"./RemixIcon/Map/bike-fill.svg": 689390,
	"./RemixIcon/Map/bike-line.svg": 313251,
	"./RemixIcon/Map/bus-2-fill.svg": 625012,
	"./RemixIcon/Map/bus-2-line.svg": 85009,
	"./RemixIcon/Map/bus-fill.svg": 655875,
	"./RemixIcon/Map/bus-line.svg": 631390,
	"./RemixIcon/Map/bus-wifi-fill.svg": 710371,
	"./RemixIcon/Map/bus-wifi-line.svg": 385278,
	"./RemixIcon/Map/car-fill.svg": 443715,
	"./RemixIcon/Map/car-line.svg": 419230,
	"./RemixIcon/Map/car-washing-fill.svg": 476919,
	"./RemixIcon/Map/car-washing-line.svg": 243666,
	"./RemixIcon/Map/caravan-fill.svg": 523343,
	"./RemixIcon/Map/caravan-line.svg": 181674,
	"./RemixIcon/Map/charging-pile-2-fill.svg": 747896,
	"./RemixIcon/Map/charging-pile-2-line.svg": 911621,
	"./RemixIcon/Map/charging-pile-fill.svg": 218607,
	"./RemixIcon/Map/charging-pile-line.svg": 402506,
	"./RemixIcon/Map/china-railway-fill.svg": 976264,
	"./RemixIcon/Map/china-railway-line.svg": 446850,
	"./RemixIcon/Map/compass-2-fill.svg": 890738,
	"./RemixIcon/Map/compass-2-line.svg": 709127,
	"./RemixIcon/Map/compass-3-fill.svg": 88317,
	"./RemixIcon/Map/compass-3-line.svg": 876224,
	"./RemixIcon/Map/compass-4-fill.svg": 856232,
	"./RemixIcon/Map/compass-4-line.svg": 818229,
	"./RemixIcon/Map/compass-discover-fill.svg": 260091,
	"./RemixIcon/Map/compass-discover-line.svg": 888822,
	"./RemixIcon/Map/compass-fill.svg": 285397,
	"./RemixIcon/Map/compass-line.svg": 74648,
	"./RemixIcon/Map/cup-fill.svg": 877853,
	"./RemixIcon/Map/cup-line.svg": 550496,
	"./RemixIcon/Map/direction-fill.svg": 942380,
	"./RemixIcon/Map/direction-line.svg": 145001,
	"./RemixIcon/Map/e-bike-2-fill.svg": 973319,
	"./RemixIcon/Map/e-bike-2-line.svg": 347618,
	"./RemixIcon/Map/e-bike-fill.svg": 302532,
	"./RemixIcon/Map/e-bike-line.svg": 711393,
	"./RemixIcon/Map/earth-fill.svg": 862333,
	"./RemixIcon/Map/earth-line.svg": 166592,
	"./RemixIcon/Map/flight-land-fill.svg": 537473,
	"./RemixIcon/Map/flight-land-line.svg": 713796,
	"./RemixIcon/Map/flight-takeoff-fill.svg": 114416,
	"./RemixIcon/Map/flight-takeoff-line.svg": 192221,
	"./RemixIcon/Map/footprint-fill.svg": 578786,
	"./RemixIcon/Map/footprint-line.svg": 274551,
	"./RemixIcon/Map/gas-station-fill.svg": 348793,
	"./RemixIcon/Map/gas-station-line.svg": 505500,
	"./RemixIcon/Map/globe-fill.svg": 275628,
	"./RemixIcon/Map/globe-line.svg": 994601,
	"./RemixIcon/Map/goblet-fill.svg": 983082,
	"./RemixIcon/Map/goblet-line.svg": 826111,
	"./RemixIcon/Map/guide-fill.svg": 722185,
	"./RemixIcon/Map/guide-line.svg": 732652,
	"./RemixIcon/Map/hotel-bed-fill.svg": 479957,
	"./RemixIcon/Map/hotel-bed-line.svg": 442264,
	"./RemixIcon/Map/lifebuoy-fill.svg": 510984,
	"./RemixIcon/Map/lifebuoy-line.svg": 852245,
	"./RemixIcon/Map/luggage-cart-fill.svg": 154278,
	"./RemixIcon/Map/luggage-cart-line.svg": 583739,
	"./RemixIcon/Map/luggage-deposit-fill.svg": 932834,
	"./RemixIcon/Map/luggage-deposit-line.svg": 376055,
	"./RemixIcon/Map/map-2-fill.svg": 20924,
	"./RemixIcon/Map/map-2-line.svg": 250425,
	"./RemixIcon/Map/map-fill.svg": 888315,
	"./RemixIcon/Map/map-line.svg": 139766,
	"./RemixIcon/Map/map-pin-2-fill.svg": 311342,
	"./RemixIcon/Map/map-pin-2-line.svg": 451555,
	"./RemixIcon/Map/map-pin-3-fill.svg": 182505,
	"./RemixIcon/Map/map-pin-3-line.svg": 459084,
	"./RemixIcon/Map/map-pin-4-fill.svg": 406460,
	"./RemixIcon/Map/map-pin-4-line.svg": 776633,
	"./RemixIcon/Map/map-pin-5-fill.svg": 692111,
	"./RemixIcon/Map/map-pin-5-line.svg": 876714,
	"./RemixIcon/Map/map-pin-add-fill.svg": 189235,
	"./RemixIcon/Map/map-pin-add-line.svg": 373198,
	"./RemixIcon/Map/map-pin-fill.svg": 112969,
	"./RemixIcon/Map/map-pin-line.svg": 326764,
	"./RemixIcon/Map/map-pin-range-fill.svg": 802613,
	"./RemixIcon/Map/map-pin-range-line.svg": 187896,
	"./RemixIcon/Map/map-pin-time-fill.svg": 76857,
	"./RemixIcon/Map/map-pin-time-line.svg": 654556,
	"./RemixIcon/Map/map-pin-user-fill.svg": 865119,
	"./RemixIcon/Map/map-pin-user-line.svg": 672186,
	"./RemixIcon/Map/motorbike-fill.svg": 590621,
	"./RemixIcon/Map/motorbike-line.svg": 103392,
	"./RemixIcon/Map/navigation-fill.svg": 141065,
	"./RemixIcon/Map/navigation-line.svg": 151532,
	"./RemixIcon/Map/oil-fill.svg": 59673,
	"./RemixIcon/Map/oil-line.svg": 271292,
	"./RemixIcon/Map/parking-box-fill.svg": 310777,
	"./RemixIcon/Map/parking-box-line.svg": 467484,
	"./RemixIcon/Map/parking-fill.svg": 783885,
	"./RemixIcon/Map/parking-line.svg": 599248,
	"./RemixIcon/Map/passport-fill.svg": 466281,
	"./RemixIcon/Map/passport-line.svg": 742860,
	"./RemixIcon/Map/pin-distance-fill.svg": 610746,
	"./RemixIcon/Map/pin-distance-line.svg": 349327,
	"./RemixIcon/Map/plane-fill.svg": 397495,
	"./RemixIcon/Map/plane-line.svg": 647890,
	"./RemixIcon/Map/police-car-fill.svg": 129906,
	"./RemixIcon/Map/police-car-line.svg": 8647,
	"./RemixIcon/Map/pushpin-2-fill.svg": 808745,
	"./RemixIcon/Map/pushpin-2-line.svg": 568972,
	"./RemixIcon/Map/pushpin-fill.svg": 264122,
	"./RemixIcon/Map/pushpin-line.svg": 100623,
	"./RemixIcon/Map/restaurant-2-fill.svg": 713251,
	"./RemixIcon/Map/restaurant-2-line.svg": 551934,
	"./RemixIcon/Map/restaurant-fill.svg": 466168,
	"./RemixIcon/Map/restaurant-line.svg": 629893,
	"./RemixIcon/Map/riding-fill.svg": 401134,
	"./RemixIcon/Map/riding-line.svg": 297571,
	"./RemixIcon/Map/road-map-fill.svg": 517778,
	"./RemixIcon/Map/road-map-line.svg": 344935,
	"./RemixIcon/Map/roadster-fill.svg": 910793,
	"./RemixIcon/Map/roadster-line.svg": 921260,
	"./RemixIcon/Map/rocket-2-fill.svg": 931560,
	"./RemixIcon/Map/rocket-2-line.svg": 774709,
	"./RemixIcon/Map/rocket-fill.svg": 93183,
	"./RemixIcon/Map/rocket-line.svg": 193946,
	"./RemixIcon/Map/route-fill.svg": 190928,
	"./RemixIcon/Map/route-line.svg": 149885,
	"./RemixIcon/Map/run-fill.svg": 534356,
	"./RemixIcon/Map/run-line.svg": 19761,
	"./RemixIcon/Map/sailboat-fill.svg": 277996,
	"./RemixIcon/Map/sailboat-line.svg": 996969,
	"./RemixIcon/Map/ship-2-fill.svg": 576010,
	"./RemixIcon/Map/ship-2-line.svg": 170591,
	"./RemixIcon/Map/ship-fill.svg": 292957,
	"./RemixIcon/Map/ship-line.svg": 965600,
	"./RemixIcon/Map/signal-tower-fill.svg": 381627,
	"./RemixIcon/Map/signal-tower-line.svg": 10358,
	"./RemixIcon/Map/space-ship-fill.svg": 429812,
	"./RemixIcon/Map/space-ship-line.svg": 406161,
	"./RemixIcon/Map/steering-2-fill.svg": 285911,
	"./RemixIcon/Map/steering-2-line.svg": 904498,
	"./RemixIcon/Map/steering-fill.svg": 765684,
	"./RemixIcon/Map/steering-line.svg": 466385,
	"./RemixIcon/Map/subway-fill.svg": 122394,
	"./RemixIcon/Map/subway-line.svg": 254575,
	"./RemixIcon/Map/subway-wifi-fill.svg": 192168,
	"./RemixIcon/Map/subway-wifi-line.svg": 35317,
	"./RemixIcon/Map/suitcase-2-fill.svg": 411753,
	"./RemixIcon/Map/suitcase-2-line.svg": 688332,
	"./RemixIcon/Map/suitcase-3-fill.svg": 540590,
	"./RemixIcon/Map/suitcase-3-line.svg": 164451,
	"./RemixIcon/Map/suitcase-fill.svg": 517818,
	"./RemixIcon/Map/suitcase-line.svg": 354319,
	"./RemixIcon/Map/takeaway-fill.svg": 669922,
	"./RemixIcon/Map/takeaway-line.svg": 849335,
	"./RemixIcon/Map/taxi-fill.svg": 760587,
	"./RemixIcon/Map/taxi-line.svg": 553734,
	"./RemixIcon/Map/taxi-wifi-fill.svg": 122123,
	"./RemixIcon/Map/taxi-wifi-line.svg": 915270,
	"./RemixIcon/Map/traffic-light-fill.svg": 179665,
	"./RemixIcon/Map/traffic-light-line.svg": 65428,
	"./RemixIcon/Map/train-fill.svg": 753083,
	"./RemixIcon/Map/train-line.svg": 381814,
	"./RemixIcon/Map/train-wifi-fill.svg": 787259,
	"./RemixIcon/Map/train-wifi-line.svg": 899638,
	"./RemixIcon/Map/treasure-map-fill.svg": 481329,
	"./RemixIcon/Map/treasure-map-line.svg": 158644,
	"./RemixIcon/Map/truck-fill.svg": 552878,
	"./RemixIcon/Map/truck-line.svg": 176739,
	"./RemixIcon/Map/walk-fill.svg": 879950,
	"./RemixIcon/Map/walk-line.svg": 137731,
	"./RemixIcon/Media/4k-fill.svg": 257284,
	"./RemixIcon/Media/4k-line.svg": 666145,
	"./RemixIcon/Media/album-fill.svg": 182508,
	"./RemixIcon/Media/album-line.svg": 927657,
	"./RemixIcon/Media/aspect-ratio-fill.svg": 72039,
	"./RemixIcon/Media/aspect-ratio-line.svg": 90754,
	"./RemixIcon/Media/broadcast-fill.svg": 120692,
	"./RemixIcon/Media/broadcast-line.svg": 305041,
	"./RemixIcon/Media/camera-2-fill.svg": 411913,
	"./RemixIcon/Media/camera-2-line.svg": 142060,
	"./RemixIcon/Media/camera-3-fill.svg": 840526,
	"./RemixIcon/Media/camera-3-line.svg": 119107,
	"./RemixIcon/Media/camera-fill.svg": 405338,
	"./RemixIcon/Media/camera-lens-fill.svg": 124729,
	"./RemixIcon/Media/camera-lens-line.svg": 702428,
	"./RemixIcon/Media/camera-line.svg": 537519,
	"./RemixIcon/Media/camera-off-fill.svg": 974966,
	"./RemixIcon/Media/camera-off-line.svg": 615499,
	"./RemixIcon/Media/camera-switch-fill.svg": 158513,
	"./RemixIcon/Media/camera-switch-line.svg": 713076,
	"./RemixIcon/Media/clapperboard-fill.svg": 833034,
	"./RemixIcon/Media/clapperboard-line.svg": 898911,
	"./RemixIcon/Media/closed-captioning-fill.svg": 575990,
	"./RemixIcon/Media/closed-captioning-line.svg": 732875,
	"./RemixIcon/Media/disc-fill.svg": 713308,
	"./RemixIcon/Media/disc-line.svg": 448857,
	"./RemixIcon/Media/dv-fill.svg": 365587,
	"./RemixIcon/Media/dv-line.svg": 31278,
	"./RemixIcon/Media/dvd-fill.svg": 939493,
	"./RemixIcon/Media/dvd-line.svg": 967080,
	"./RemixIcon/Media/eject-fill.svg": 858150,
	"./RemixIcon/Media/eject-line.svg": 536443,
	"./RemixIcon/Media/equalizer-fill.svg": 749115,
	"./RemixIcon/Media/equalizer-line.svg": 566,
	"./RemixIcon/Media/film-fill.svg": 11007,
	"./RemixIcon/Media/film-line.svg": 537754,
	"./RemixIcon/Media/fullscreen-exit-fill.svg": 649767,
	"./RemixIcon/Media/fullscreen-exit-line.svg": 668482,
	"./RemixIcon/Media/fullscreen-fill.svg": 415372,
	"./RemixIcon/Media/fullscreen-line.svg": 446729,
	"./RemixIcon/Media/gallery-fill.svg": 724229,
	"./RemixIcon/Media/gallery-line.svg": 600264,
	"./RemixIcon/Media/gallery-upload-fill.svg": 404473,
	"./RemixIcon/Media/gallery-upload-line.svg": 498524,
	"./RemixIcon/Media/hd-fill.svg": 803141,
	"./RemixIcon/Media/hd-line.svg": 21832,
	"./RemixIcon/Media/headphone-fill.svg": 352617,
	"./RemixIcon/Media/headphone-line.svg": 130380,
	"./RemixIcon/Media/hq-fill.svg": 243806,
	"./RemixIcon/Media/hq-line.svg": 64019,
	"./RemixIcon/Media/image-2-fill.svg": 224397,
	"./RemixIcon/Media/image-2-line.svg": 523408,
	"./RemixIcon/Media/image-add-fill.svg": 560980,
	"./RemixIcon/Media/image-add-line.svg": 530033,
	"./RemixIcon/Media/image-edit-fill.svg": 792609,
	"./RemixIcon/Media/image-edit-line.svg": 543652,
	"./RemixIcon/Media/image-fill.svg": 543782,
	"./RemixIcon/Media/image-line.svg": 973243,
	"./RemixIcon/Media/landscape-fill.svg": 813126,
	"./RemixIcon/Media/landscape-line.svg": 43739,
	"./RemixIcon/Media/live-fill.svg": 452483,
	"./RemixIcon/Media/live-line.svg": 749342,
	"./RemixIcon/Media/mic-2-fill.svg": 314483,
	"./RemixIcon/Media/mic-2-line.svg": 498446,
	"./RemixIcon/Media/mic-fill.svg": 741992,
	"./RemixIcon/Media/mic-line.svg": 585141,
	"./RemixIcon/Media/mic-off-fill.svg": 319432,
	"./RemixIcon/Media/mic-off-line.svg": 567637,
	"./RemixIcon/Media/movie-2-fill.svg": 929212,
	"./RemixIcon/Media/movie-2-line.svg": 299385,
	"./RemixIcon/Media/movie-fill.svg": 613243,
	"./RemixIcon/Media/movie-line.svg": 241974,
	"./RemixIcon/Media/music-2-fill.svg": 456235,
	"./RemixIcon/Media/music-2-line.svg": 249382,
	"./RemixIcon/Media/music-fill.svg": 486032,
	"./RemixIcon/Media/music-line.svg": 865981,
	"./RemixIcon/Media/mv-fill.svg": 273610,
	"./RemixIcon/Media/mv-line.svg": 351839,
	"./RemixIcon/Media/notification-2-fill.svg": 483481,
	"./RemixIcon/Media/notification-2-line.svg": 588604,
	"./RemixIcon/Media/notification-3-fill.svg": 959710,
	"./RemixIcon/Media/notification-3-line.svg": 13267,
	"./RemixIcon/Media/notification-4-fill.svg": 635071,
	"./RemixIcon/Media/notification-4-line.svg": 735834,
	"./RemixIcon/Media/notification-fill.svg": 515722,
	"./RemixIcon/Media/notification-line.svg": 110303,
	"./RemixIcon/Media/notification-off-fill.svg": 148390,
	"./RemixIcon/Media/notification-off-line.svg": 826683,
	"./RemixIcon/Media/order-play-fill.svg": 343924,
	"./RemixIcon/Media/order-play-line.svg": 803921,
	"./RemixIcon/Media/pause-circle-fill.svg": 938100,
	"./RemixIcon/Media/pause-circle-line.svg": 122449,
	"./RemixIcon/Media/pause-fill.svg": 551321,
	"./RemixIcon/Media/pause-line.svg": 172796,
	"./RemixIcon/Media/pause-mini-fill.svg": 834983,
	"./RemixIcon/Media/pause-mini-line.svg": 337346,
	"./RemixIcon/Media/phone-camera-fill.svg": 155641,
	"./RemixIcon/Media/phone-camera-line.svg": 733340,
	"./RemixIcon/Media/picture-in-picture-2-fill.svg": 173887,
	"./RemixIcon/Media/picture-in-picture-2-line.svg": 791002,
	"./RemixIcon/Media/picture-in-picture-exit-fill.svg": 890855,
	"./RemixIcon/Media/picture-in-picture-exit-line.svg": 909570,
	"./RemixIcon/Media/picture-in-picture-fill.svg": 606732,
	"./RemixIcon/Media/picture-in-picture-line.svg": 638089,
	"./RemixIcon/Media/play-circle-fill.svg": 475846,
	"./RemixIcon/Media/play-circle-line.svg": 706459,
	"./RemixIcon/Media/play-fill.svg": 831867,
	"./RemixIcon/Media/play-line.svg": 83318,
	"./RemixIcon/Media/play-list-2-fill.svg": 979329,
	"./RemixIcon/Media/play-list-2-line.svg": 826628,
	"./RemixIcon/Media/play-list-add-fill.svg": 663064,
	"./RemixIcon/Media/play-list-add-line.svg": 429797,
	"./RemixIcon/Media/play-list-fill.svg": 445282,
	"./RemixIcon/Media/play-list-line.svg": 624695,
	"./RemixIcon/Media/play-mini-fill.svg": 111209,
	"./RemixIcon/Media/play-mini-line.svg": 888972,
	"./RemixIcon/Media/polaroid-2-fill.svg": 989738,
	"./RemixIcon/Media/polaroid-2-line.svg": 832767,
	"./RemixIcon/Media/polaroid-fill.svg": 213565,
	"./RemixIcon/Media/polaroid-line.svg": 1472,
	"./RemixIcon/Media/radio-2-fill.svg": 334419,
	"./RemixIcon/Media/radio-2-line.svg": 516462,
	"./RemixIcon/Media/radio-fill.svg": 335624,
	"./RemixIcon/Media/radio-line.svg": 100181,
	"./RemixIcon/Media/record-circle-fill.svg": 565539,
	"./RemixIcon/Media/record-circle-line.svg": 240446,
	"./RemixIcon/Media/repeat-2-fill.svg": 83153,
	"./RemixIcon/Media/repeat-2-line.svg": 372564,
	"./RemixIcon/Media/repeat-fill.svg": 783250,
	"./RemixIcon/Media/repeat-line.svg": 610407,
	"./RemixIcon/Media/repeat-one-fill.svg": 390667,
	"./RemixIcon/Media/repeat-one-line.svg": 183814,
	"./RemixIcon/Media/rewind-fill.svg": 513150,
	"./RemixIcon/Media/rewind-line.svg": 413747,
	"./RemixIcon/Media/rewind-mini-fill.svg": 287398,
	"./RemixIcon/Media/rewind-mini-line.svg": 965691,
	"./RemixIcon/Media/rhythm-fill.svg": 329457,
	"./RemixIcon/Media/rhythm-line.svg": 523124,
	"./RemixIcon/Media/shuffle-fill.svg": 518170,
	"./RemixIcon/Media/shuffle-line.svg": 445423,
	"./RemixIcon/Media/skip-back-fill.svg": 611398,
	"./RemixIcon/Media/skip-back-line.svg": 422875,
	"./RemixIcon/Media/skip-back-mini-fill.svg": 221966,
	"./RemixIcon/Media/skip-back-mini-line.svg": 500547,
	"./RemixIcon/Media/skip-forward-fill.svg": 888570,
	"./RemixIcon/Media/skip-forward-line.svg": 241423,
	"./RemixIcon/Media/skip-forward-mini-fill.svg": 461586,
	"./RemixIcon/Media/skip-forward-mini-line.svg": 958119,
	"./RemixIcon/Media/sound-module-fill.svg": 460015,
	"./RemixIcon/Media/sound-module-line.svg": 127562,
	"./RemixIcon/Media/speaker-2-fill.svg": 729085,
	"./RemixIcon/Media/speaker-2-line.svg": 350144,
	"./RemixIcon/Media/speaker-3-fill.svg": 902642,
	"./RemixIcon/Media/speaker-3-line.svg": 781383,
	"./RemixIcon/Media/speaker-fill.svg": 481142,
	"./RemixIcon/Media/speaker-line.svg": 638027,
	"./RemixIcon/Media/speed-fill.svg": 888216,
	"./RemixIcon/Media/speed-line.svg": 434725,
	"./RemixIcon/Media/speed-mini-fill.svg": 406792,
	"./RemixIcon/Media/speed-mini-line.svg": 231701,
	"./RemixIcon/Media/stop-circle-fill.svg": 124716,
	"./RemixIcon/Media/stop-circle-line.svg": 869865,
	"./RemixIcon/Media/stop-fill.svg": 103057,
	"./RemixIcon/Media/stop-line.svg": 988820,
	"./RemixIcon/Media/stop-mini-fill.svg": 378207,
	"./RemixIcon/Media/stop-mini-line.svg": 185274,
	"./RemixIcon/Media/surround-sound-fill.svg": 854485,
	"./RemixIcon/Media/surround-sound-line.svg": 816792,
	"./RemixIcon/Media/tape-fill.svg": 280793,
	"./RemixIcon/Media/tape-line.svg": 492412,
	"./RemixIcon/Media/video-add-fill.svg": 475310,
	"./RemixIcon/Media/video-add-line.svg": 99171,
	"./RemixIcon/Media/video-download-fill.svg": 739655,
	"./RemixIcon/Media/video-download-line.svg": 559906,
	"./RemixIcon/Media/video-fill.svg": 176752,
	"./RemixIcon/Media/video-line.svg": 254557,
	"./RemixIcon/Media/video-upload-fill.svg": 471670,
	"./RemixIcon/Media/video-upload-line.svg": 992971,
	"./RemixIcon/Media/vidicon-2-fill.svg": 692306,
	"./RemixIcon/Media/vidicon-2-line.svg": 35815,
	"./RemixIcon/Media/vidicon-fill.svg": 554293,
	"./RemixIcon/Media/vidicon-line.svg": 939576,
	"./RemixIcon/Media/voiceprint-fill.svg": 22000,
	"./RemixIcon/Media/voiceprint-line.svg": 99805,
	"./RemixIcon/Media/volume-down-fill.svg": 145986,
	"./RemixIcon/Media/volume-down-line.svg": 637207,
	"./RemixIcon/Media/volume-mute-fill.svg": 470307,
	"./RemixIcon/Media/volume-mute-line.svg": 308990,
	"./RemixIcon/Media/volume-off-vibrate-fill.svg": 501369,
	"./RemixIcon/Media/volume-off-vibrate-line.svg": 658076,
	"./RemixIcon/Media/volume-up-fill.svg": 257495,
	"./RemixIcon/Media/volume-up-line.svg": 876082,
	"./RemixIcon/Media/volume-vibrate-fill.svg": 607009,
	"./RemixIcon/Media/volume-vibrate-line.svg": 593700,
	"./RemixIcon/Media/webcam-fill.svg": 110380,
	"./RemixIcon/Media/webcam-line.svg": 313001,
	"./RemixIcon/Others/basketball-fill.svg": 102387,
	"./RemixIcon/Others/basketball-line.svg": 286350,
	"./RemixIcon/Others/bell-fill.svg": 560017,
	"./RemixIcon/Others/bell-line.svg": 333076,
	"./RemixIcon/Others/billiards-fill.svg": 642402,
	"./RemixIcon/Others/billiards-line.svg": 338167,
	"./RemixIcon/Others/boxing-fill.svg": 568887,
	"./RemixIcon/Others/boxing-line.svg": 819282,
	"./RemixIcon/Others/cactus-fill.svg": 989859,
	"./RemixIcon/Others/cactus-line.svg": 312190,
	"./RemixIcon/Others/cake-2-fill.svg": 85111,
	"./RemixIcon/Others/cake-2-line.svg": 783762,
	"./RemixIcon/Others/cake-3-fill.svg": 769444,
	"./RemixIcon/Others/cake-3-line.svg": 755009,
	"./RemixIcon/Others/cake-fill.svg": 840404,
	"./RemixIcon/Others/cake-line.svg": 325809,
	"./RemixIcon/Others/character-recognition-fill.svg": 212649,
	"./RemixIcon/Others/character-recognition-line.svg": 990412,
	"./RemixIcon/Others/door-closed-fill.svg": 270967,
	"./RemixIcon/Others/door-closed-line.svg": 521362,
	"./RemixIcon/Others/door-fill.svg": 257932,
	"./RemixIcon/Others/door-line.svg": 805641,
	"./RemixIcon/Others/door-lock-box-fill.svg": 69644,
	"./RemixIcon/Others/door-lock-box-line.svg": 101001,
	"./RemixIcon/Others/door-lock-fill.svg": 615508,
	"./RemixIcon/Others/door-lock-line.svg": 584561,
	"./RemixIcon/Others/door-open-fill.svg": 762699,
	"./RemixIcon/Others/door-open-line.svg": 72198,
	"./RemixIcon/Others/football-fill.svg": 311725,
	"./RemixIcon/Others/football-line.svg": 194736,
	"./RemixIcon/Others/fridge-fill.svg": 809265,
	"./RemixIcon/Others/fridge-line.svg": 363828,
	"./RemixIcon/Others/game-fill.svg": 698434,
	"./RemixIcon/Others/game-line.svg": 706007,
	"./RemixIcon/Others/handbag-fill.svg": 55065,
	"./RemixIcon/Others/handbag-line.svg": 266684,
	"./RemixIcon/Others/key-2-fill.svg": 42128,
	"./RemixIcon/Others/key-2-line.svg": 422077,
	"./RemixIcon/Others/key-fill.svg": 178103,
	"./RemixIcon/Others/key-line.svg": 876754,
	"./RemixIcon/Others/knife-blood-fill.svg": 33824,
	"./RemixIcon/Others/knife-blood-line.svg": 810189,
	"./RemixIcon/Others/knife-fill.svg": 574933,
	"./RemixIcon/Others/knife-line.svg": 847832,
	"./RemixIcon/Others/leaf-fill.svg": 197060,
	"./RemixIcon/Others/leaf-line.svg": 885025,
	"./RemixIcon/Others/lightbulb-fill.svg": 150971,
	"./RemixIcon/Others/lightbulb-flash-fill.svg": 113336,
	"./RemixIcon/Others/lightbulb-flash-line.svg": 157829,
	"./RemixIcon/Others/lightbulb-line.svg": 402422,
	"./RemixIcon/Others/outlet-2-fill.svg": 934726,
	"./RemixIcon/Others/outlet-2-line.svg": 229851,
	"./RemixIcon/Others/outlet-fill.svg": 512273,
	"./RemixIcon/Others/outlet-line.svg": 801684,
	"./RemixIcon/Others/ping-pong-fill.svg": 810121,
	"./RemixIcon/Others/ping-pong-line.svg": 540268,
	"./RemixIcon/Others/plant-fill.svg": 806649,
	"./RemixIcon/Others/plant-line.svg": 963356,
	"./RemixIcon/Others/plug-2-fill.svg": 750803,
	"./RemixIcon/Others/plug-2-line.svg": 416494,
	"./RemixIcon/Others/plug-fill.svg": 891144,
	"./RemixIcon/Others/plug-line.svg": 655701,
	"./RemixIcon/Others/recycle-fill.svg": 184065,
	"./RemixIcon/Others/recycle-line.svg": 360388,
	"./RemixIcon/Others/reserved-fill.svg": 313628,
	"./RemixIcon/Others/reserved-line.svg": 672345,
	"./RemixIcon/Others/scales-2-fill.svg": 147576,
	"./RemixIcon/Others/scales-2-line.svg": 192069,
	"./RemixIcon/Others/scales-3-fill.svg": 432507,
	"./RemixIcon/Others/scales-3-line.svg": 200310,
	"./RemixIcon/Others/scales-fill.svg": 297308,
	"./RemixIcon/Others/scales-line.svg": 446474,
	"./RemixIcon/Others/seedling-fill.svg": 421325,
	"./RemixIcon/Others/seedling-line.svg": 720336,
	"./RemixIcon/Others/shirt-fill.svg": 91436,
	"./RemixIcon/Others/shirt-line.svg": 294057,
	"./RemixIcon/Others/sword-fill.svg": 611473,
	"./RemixIcon/Others/sword-line.svg": 497236,
	"./RemixIcon/Others/t-shirt-2-fill.svg": 513490,
	"./RemixIcon/Others/t-shirt-2-line.svg": 340647,
	"./RemixIcon/Others/t-shirt-air-fill.svg": 101300,
	"./RemixIcon/Others/t-shirt-air-line.svg": 285649,
	"./RemixIcon/Others/t-shirt-fill.svg": 805813,
	"./RemixIcon/Others/t-shirt-line.svg": 191096,
	"./RemixIcon/Others/umbrella-fill.svg": 739524,
	"./RemixIcon/Others/umbrella-line.svg": 427489,
	"./RemixIcon/Others/voice-recognition-fill.svg": 503100,
	"./RemixIcon/Others/voice-recognition-line.svg": 732601,
	"./RemixIcon/Others/wheelchair-fill.svg": 20868,
	"./RemixIcon/Others/wheelchair-line.svg": 429729,
	"./RemixIcon/System/add-box-fill.svg": 532197,
	"./RemixIcon/System/add-box-line.svg": 424808,
	"./RemixIcon/System/add-circle-fill.svg": 77460,
	"./RemixIcon/System/add-circle-line.svg": 562865,
	"./RemixIcon/System/add-fill.svg": 335673,
	"./RemixIcon/System/add-line.svg": 913372,
	"./RemixIcon/System/alarm-fill.svg": 605999,
	"./RemixIcon/System/alarm-line.svg": 977546,
	"./RemixIcon/System/alarm-warning-fill.svg": 101002,
	"./RemixIcon/System/alarm-warning-line.svg": 695583,
	"./RemixIcon/System/alert-fill.svg": 754480,
	"./RemixIcon/System/alert-line.svg": 180829,
	"./RemixIcon/System/apps-2-fill.svg": 848021,
	"./RemixIcon/System/apps-2-line.svg": 637272,
	"./RemixIcon/System/apps-fill.svg": 392830,
	"./RemixIcon/System/apps-line.svg": 293427,
	"./RemixIcon/System/arrow-down-circle-fill.svg": 224085,
	"./RemixIcon/System/arrow-down-circle-line.svg": 13336,
	"./RemixIcon/System/arrow-down-fill.svg": 858182,
	"./RemixIcon/System/arrow-down-line.svg": 572443,
	"./RemixIcon/System/arrow-down-s-fill.svg": 901922,
	"./RemixIcon/System/arrow-down-s-line.svg": 861495,
	"./RemixIcon/System/arrow-drop-down-fill.svg": 469430,
	"./RemixIcon/System/arrow-drop-down-line.svg": 626315,
	"./RemixIcon/System/arrow-drop-left-fill.svg": 956351,
	"./RemixIcon/System/arrow-drop-left-line.svg": 57114,
	"./RemixIcon/System/arrow-drop-right-fill.svg": 783064,
	"./RemixIcon/System/arrow-drop-right-line.svg": 549797,
	"./RemixIcon/System/arrow-drop-up-fill.svg": 961235,
	"./RemixIcon/System/arrow-drop-up-line.svg": 626926,
	"./RemixIcon/System/arrow-go-back-fill.svg": 962740,
	"./RemixIcon/System/arrow-go-back-line.svg": 663441,
	"./RemixIcon/System/arrow-go-forward-fill.svg": 939380,
	"./RemixIcon/System/arrow-go-forward-line.svg": 399377,
	"./RemixIcon/System/arrow-left-circle-fill.svg": 313898,
	"./RemixIcon/System/arrow-left-circle-line.svg": 147007,
	"./RemixIcon/System/arrow-left-down-fill.svg": 97970,
	"./RemixIcon/System/arrow-left-down-line.svg": 400007,
	"./RemixIcon/System/arrow-left-fill.svg": 724175,
	"./RemixIcon/System/arrow-left-line.svg": 898858,
	"./RemixIcon/System/arrow-left-right-fill.svg": 118972,
	"./RemixIcon/System/arrow-left-right-line.svg": 489145,
	"./RemixIcon/System/arrow-left-s-fill.svg": 828827,
	"./RemixIcon/System/arrow-left-s-line.svg": 530710,
	"./RemixIcon/System/arrow-left-up-fill.svg": 314919,
	"./RemixIcon/System/arrow-left-up-line.svg": 610050,
	"./RemixIcon/System/arrow-right-circle-fill.svg": 452623,
	"./RemixIcon/System/arrow-right-circle-line.svg": 637226,
	"./RemixIcon/System/arrow-right-down-fill.svg": 2227,
	"./RemixIcon/System/arrow-right-down-line.svg": 435022,
	"./RemixIcon/System/arrow-right-fill.svg": 194280,
	"./RemixIcon/System/arrow-right-line.svg": 37429,
	"./RemixIcon/System/arrow-right-s-fill.svg": 861744,
	"./RemixIcon/System/arrow-right-s-line.svg": 288093,
	"./RemixIcon/System/arrow-right-up-fill.svg": 528234,
	"./RemixIcon/System/arrow-right-up-line.svg": 361343,
	"./RemixIcon/System/arrow-up-circle-fill.svg": 24302,
	"./RemixIcon/System/arrow-up-circle-line.svg": 404387,
	"./RemixIcon/System/arrow-up-down-fill.svg": 341062,
	"./RemixIcon/System/arrow-up-down-line.svg": 55323,
	"./RemixIcon/System/arrow-up-fill.svg": 715459,
	"./RemixIcon/System/arrow-up-line.svg": 207326,
	"./RemixIcon/System/arrow-up-s-fill.svg": 58759,
	"./RemixIcon/System/arrow-up-s-line.svg": 879010,
	"./RemixIcon/System/check-double-fill.svg": 795604,
	"./RemixIcon/System/check-double-line.svg": 764657,
	"./RemixIcon/System/check-fill.svg": 922398,
	"./RemixIcon/System/check-line.svg": 742611,
	"./RemixIcon/System/checkbox-blank-circle-fill.svg": 921355,
	"./RemixIcon/System/checkbox-blank-circle-line.svg": 133638,
	"./RemixIcon/System/checkbox-blank-fill.svg": 248004,
	"./RemixIcon/System/checkbox-blank-line.svg": 419617,
	"./RemixIcon/System/checkbox-circle-fill.svg": 721710,
	"./RemixIcon/System/checkbox-circle-line.svg": 618147,
	"./RemixIcon/System/checkbox-fill.svg": 593603,
	"./RemixIcon/System/checkbox-indeterminate-fill.svg": 153197,
	"./RemixIcon/System/checkbox-indeterminate-line.svg": 356912,
	"./RemixIcon/System/checkbox-line.svg": 85470,
	"./RemixIcon/System/checkbox-multiple-blank-fill.svg": 644137,
	"./RemixIcon/System/checkbox-multiple-blank-line.svg": 421900,
	"./RemixIcon/System/checkbox-multiple-fill.svg": 808718,
	"./RemixIcon/System/checkbox-multiple-line.svg": 66499,
	"./RemixIcon/System/close-circle-fill.svg": 453377,
	"./RemixIcon/System/close-circle-line.svg": 300676,
	"./RemixIcon/System/close-fill.svg": 655602,
	"./RemixIcon/System/close-line.svg": 534343,
	"./RemixIcon/System/dashboard-fill.svg": 357106,
	"./RemixIcon/System/dashboard-line.svg": 659143,
	"./RemixIcon/System/delete-back-2-fill.svg": 374436,
	"./RemixIcon/System/delete-back-2-line.svg": 360001,
	"./RemixIcon/System/delete-back-fill.svg": 236691,
	"./RemixIcon/System/delete-back-line.svg": 902254,
	"./RemixIcon/System/delete-bin-2-fill.svg": 476226,
	"./RemixIcon/System/delete-bin-2-line.svg": 636823,
	"./RemixIcon/System/delete-bin-3-fill.svg": 360077,
	"./RemixIcon/System/delete-bin-3-line.svg": 175440,
	"./RemixIcon/System/delete-bin-4-fill.svg": 700600,
	"./RemixIcon/System/delete-bin-4-line.svg": 745093,
	"./RemixIcon/System/delete-bin-5-fill.svg": 985531,
	"./RemixIcon/System/delete-bin-5-line.svg": 236982,
	"./RemixIcon/System/delete-bin-6-fill.svg": 960694,
	"./RemixIcon/System/delete-bin-6-line.svg": 117579,
	"./RemixIcon/System/delete-bin-7-fill.svg": 629617,
	"./RemixIcon/System/delete-bin-7-line.svg": 306932,
	"./RemixIcon/System/delete-bin-fill.svg": 478981,
	"./RemixIcon/System/delete-bin-line.svg": 697672,
	"./RemixIcon/System/divide-fill.svg": 78699,
	"./RemixIcon/System/divide-line.svg": 388198,
	"./RemixIcon/System/download-2-fill.svg": 680757,
	"./RemixIcon/System/download-2-line.svg": 66040,
	"./RemixIcon/System/download-cloud-2-fill.svg": 189729,
	"./RemixIcon/System/download-cloud-2-line.svg": 176420,
	"./RemixIcon/System/download-cloud-fill.svg": 690690,
	"./RemixIcon/System/download-cloud-line.svg": 181911,
	"./RemixIcon/System/download-fill.svg": 453278,
	"./RemixIcon/System/download-line.svg": 273491,
	"./RemixIcon/System/error-warning-fill.svg": 596641,
	"./RemixIcon/System/error-warning-line.svg": 66980,
	"./RemixIcon/System/external-link-fill.svg": 808304,
	"./RemixIcon/System/external-link-line.svg": 718301,
	"./RemixIcon/System/eye-2-fill.svg": 733584,
	"./RemixIcon/System/eye-2-line.svg": 113533,
	"./RemixIcon/System/eye-close-fill.svg": 407026,
	"./RemixIcon/System/eye-close-line.svg": 225415,
	"./RemixIcon/System/eye-fill.svg": 161591,
	"./RemixIcon/System/eye-line.svg": 376594,
	"./RemixIcon/System/eye-off-fill.svg": 82575,
	"./RemixIcon/System/eye-off-line.svg": 267178,
	"./RemixIcon/System/filter-2-fill.svg": 416383,
	"./RemixIcon/System/filter-2-line.svg": 517146,
	"./RemixIcon/System/filter-3-fill.svg": 570796,
	"./RemixIcon/System/filter-3-line.svg": 773417,
	"./RemixIcon/System/filter-fill.svg": 827532,
	"./RemixIcon/System/filter-line.svg": 858889,
	"./RemixIcon/System/filter-off-fill.svg": 462108,
	"./RemixIcon/System/filter-off-line.svg": 197657,
	"./RemixIcon/System/find-replace-fill.svg": 406072,
	"./RemixIcon/System/find-replace-line.svg": 450565,
	"./RemixIcon/System/forbid-2-fill.svg": 353103,
	"./RemixIcon/System/forbid-2-line.svg": 527786,
	"./RemixIcon/System/forbid-fill.svg": 367612,
	"./RemixIcon/System/forbid-line.svg": 597113,
	"./RemixIcon/System/function-fill.svg": 406110,
	"./RemixIcon/System/function-line.svg": 226323,
	"./RemixIcon/System/history-fill.svg": 424230,
	"./RemixIcon/System/history-line.svg": 102523,
	"./RemixIcon/System/indeterminate-circle-fill.svg": 19100,
	"./RemixIcon/System/indeterminate-circle-line.svg": 754649,
	"./RemixIcon/System/information-fill.svg": 282880,
	"./RemixIcon/System/information-line.svg": 735533,
	"./RemixIcon/System/list-settings-fill.svg": 702260,
	"./RemixIcon/System/list-settings-line.svg": 678609,
	"./RemixIcon/System/loader-2-fill.svg": 256574,
	"./RemixIcon/System/loader-2-line.svg": 157171,
	"./RemixIcon/System/loader-3-fill.svg": 727097,
	"./RemixIcon/System/loader-3-line.svg": 821148,
	"./RemixIcon/System/loader-4-fill.svg": 980940,
	"./RemixIcon/System/loader-4-line.svg": 435593,
	"./RemixIcon/System/loader-5-fill.svg": 664543,
	"./RemixIcon/System/loader-5-line.svg": 471610,
	"./RemixIcon/System/loader-fill.svg": 241657,
	"./RemixIcon/System/loader-line.svg": 398364,
	"./RemixIcon/System/lock-2-fill.svg": 609130,
	"./RemixIcon/System/lock-2-line.svg": 442239,
	"./RemixIcon/System/lock-fill.svg": 324733,
	"./RemixIcon/System/lock-line.svg": 945792,
	"./RemixIcon/System/lock-password-fill.svg": 841529,
	"./RemixIcon/System/lock-password-line.svg": 998236,
	"./RemixIcon/System/lock-unlock-fill.svg": 8084,
	"./RemixIcon/System/lock-unlock-line.svg": 977137,
	"./RemixIcon/System/login-box-fill.svg": 354451,
	"./RemixIcon/System/login-box-line.svg": 20142,
	"./RemixIcon/System/login-circle-fill.svg": 6106,
	"./RemixIcon/System/login-circle-line.svg": 933359,
	"./RemixIcon/System/logout-box-fill.svg": 463888,
	"./RemixIcon/System/logout-box-line.svg": 422845,
	"./RemixIcon/System/logout-box-r-fill.svg": 476267,
	"./RemixIcon/System/logout-box-r-line.svg": 785766,
	"./RemixIcon/System/logout-circle-fill.svg": 561471,
	"./RemixIcon/System/logout-circle-line.svg": 88218,
	"./RemixIcon/System/logout-circle-r-fill.svg": 627048,
	"./RemixIcon/System/logout-circle-r-line.svg": 953845,
	"./RemixIcon/System/menu-2-fill.svg": 45754,
	"./RemixIcon/System/menu-2-line.svg": 398607,
	"./RemixIcon/System/menu-3-fill.svg": 127941,
	"./RemixIcon/System/menu-3-line.svg": 520328,
	"./RemixIcon/System/menu-4-fill.svg": 671664,
	"./RemixIcon/System/menu-4-line.svg": 749469,
	"./RemixIcon/System/menu-5-fill.svg": 131315,
	"./RemixIcon/System/menu-5-line.svg": 315278,
	"./RemixIcon/System/menu-add-fill.svg": 936127,
	"./RemixIcon/System/menu-add-line.svg": 462874,
	"./RemixIcon/System/menu-fill.svg": 746925,
	"./RemixIcon/System/menu-fold-fill.svg": 990887,
	"./RemixIcon/System/menu-fold-line.svg": 9602,
	"./RemixIcon/System/menu-line.svg": 950640,
	"./RemixIcon/System/menu-unfold-fill.svg": 779740,
	"./RemixIcon/System/menu-unfold-line.svg": 654809,
	"./RemixIcon/System/more-2-fill.svg": 671292,
	"./RemixIcon/System/more-2-line.svg": 525113,
	"./RemixIcon/System/more-fill.svg": 58043,
	"./RemixIcon/System/more-line.svg": 686774,
	"./RemixIcon/System/notification-badge-fill.svg": 466959,
	"./RemixIcon/System/notification-badge-line.svg": 641642,
	"./RemixIcon/System/question-fill.svg": 726546,
	"./RemixIcon/System/question-line.svg": 223079,
	"./RemixIcon/System/radio-button-fill.svg": 41020,
	"./RemixIcon/System/radio-button-line.svg": 894841,
	"./RemixIcon/System/refresh-fill.svg": 340969,
	"./RemixIcon/System/refresh-line.svg": 635084,
	"./RemixIcon/System/search-2-fill.svg": 862705,
	"./RemixIcon/System/search-2-line.svg": 540020,
	"./RemixIcon/System/search-eye-fill.svg": 414602,
	"./RemixIcon/System/search-eye-line.svg": 492831,
	"./RemixIcon/System/search-fill.svg": 558258,
	"./RemixIcon/System/search-line.svg": 860295,
	"./RemixIcon/System/settings-2-fill.svg": 87096,
	"./RemixIcon/System/settings-2-line.svg": 131589,
	"./RemixIcon/System/settings-3-fill.svg": 372027,
	"./RemixIcon/System/settings-3-line.svg": 623478,
	"./RemixIcon/System/settings-4-fill.svg": 862722,
	"./RemixIcon/System/settings-4-line.svg": 23319,
	"./RemixIcon/System/settings-5-fill.svg": 746573,
	"./RemixIcon/System/settings-5-line.svg": 561936,
	"./RemixIcon/System/settings-6-fill.svg": 641892,
	"./RemixIcon/System/settings-6-line.svg": 53057,
	"./RemixIcon/System/settings-fill.svg": 706031,
	"./RemixIcon/System/settings-line.svg": 77578,
	"./RemixIcon/System/share-box-fill.svg": 850437,
	"./RemixIcon/System/share-box-line.svg": 69128,
	"./RemixIcon/System/share-circle-fill.svg": 487092,
	"./RemixIcon/System/share-circle-line.svg": 463441,
	"./RemixIcon/System/share-fill.svg": 734361,
	"./RemixIcon/System/share-forward-2-fill.svg": 952730,
	"./RemixIcon/System/share-forward-2-line.svg": 601263,
	"./RemixIcon/System/share-forward-box-fill.svg": 444921,
	"./RemixIcon/System/share-forward-box-line.svg": 22620,
	"./RemixIcon/System/share-forward-fill.svg": 792717,
	"./RemixIcon/System/share-forward-line.svg": 213264,
	"./RemixIcon/System/share-line.svg": 945980,
	"./RemixIcon/System/shield-check-fill.svg": 877482,
	"./RemixIcon/System/shield-check-line.svg": 710591,
	"./RemixIcon/System/shield-cross-fill.svg": 534314,
	"./RemixIcon/System/shield-cross-line.svg": 367423,
	"./RemixIcon/System/shield-fill.svg": 340387,
	"./RemixIcon/System/shield-flash-fill.svg": 423344,
	"./RemixIcon/System/shield-flash-line.svg": 849693,
	"./RemixIcon/System/shield-keyhole-fill.svg": 146983,
	"./RemixIcon/System/shield-keyhole-line.svg": 165698,
	"./RemixIcon/System/shield-line.svg": 15294,
	"./RemixIcon/System/shield-star-fill.svg": 639858,
	"./RemixIcon/System/shield-star-line.svg": 518599,
	"./RemixIcon/System/shield-user-fill.svg": 328429,
	"./RemixIcon/System/shield-user-line.svg": 15792,
	"./RemixIcon/System/side-bar-fill.svg": 345881,
	"./RemixIcon/System/side-bar-line.svg": 557500,
	"./RemixIcon/System/spam-2-fill.svg": 733060,
	"./RemixIcon/System/spam-2-line.svg": 141921,
	"./RemixIcon/System/spam-3-fill.svg": 767639,
	"./RemixIcon/System/spam-3-line.svg": 224754,
	"./RemixIcon/System/spam-fill.svg": 711347,
	"./RemixIcon/System/spam-line.svg": 895310,
	"./RemixIcon/System/star-fill.svg": 972222,
	"./RemixIcon/System/star-half-fill.svg": 794636,
	"./RemixIcon/System/star-half-line.svg": 342345,
	"./RemixIcon/System/star-half-s-fill.svg": 538860,
	"./RemixIcon/System/star-half-s-line.svg": 284009,
	"./RemixIcon/System/star-line.svg": 923891,
	"./RemixIcon/System/star-s-fill.svg": 928650,
	"./RemixIcon/System/star-s-line.svg": 994527,
	"./RemixIcon/System/subtract-fill.svg": 264178,
	"./RemixIcon/System/subtract-line.svg": 566215,
	"./RemixIcon/System/thumb-down-fill.svg": 818721,
	"./RemixIcon/System/thumb-down-line.svg": 569764,
	"./RemixIcon/System/thumb-up-fill.svg": 242180,
	"./RemixIcon/System/thumb-up-line.svg": 167393,
	"./RemixIcon/System/time-fill.svg": 346659,
	"./RemixIcon/System/time-line.svg": 668990,
	"./RemixIcon/System/timer-2-fill.svg": 277604,
	"./RemixIcon/System/timer-2-line.svg": 688769,
	"./RemixIcon/System/timer-fill.svg": 680403,
	"./RemixIcon/System/timer-flash-fill.svg": 469696,
	"./RemixIcon/System/timer-flash-line.svg": 922349,
	"./RemixIcon/System/timer-line.svg": 346094,
	"./RemixIcon/System/toggle-fill.svg": 275802,
	"./RemixIcon/System/toggle-line.svg": 924335,
	"./RemixIcon/System/upload-2-fill.svg": 636628,
	"./RemixIcon/System/upload-2-line.svg": 122033,
	"./RemixIcon/System/upload-cloud-2-fill.svg": 413352,
	"./RemixIcon/System/upload-cloud-2-line.svg": 375349,
	"./RemixIcon/System/upload-cloud-fill.svg": 775935,
	"./RemixIcon/System/upload-cloud-line.svg": 786330,
	"./RemixIcon/System/upload-fill.svg": 662243,
	"./RemixIcon/System/upload-line.svg": 500926,
	"./RemixIcon/System/zoom-in-fill.svg": 845735,
	"./RemixIcon/System/zoom-in-line.svg": 864450,
	"./RemixIcon/System/zoom-out-fill.svg": 351712,
	"./RemixIcon/System/zoom-out-line.svg": 128077,
	"./RemixIcon/User/account-box-fill.svg": 352867,
	"./RemixIcon/User/account-box-line.svg": 675198,
	"./RemixIcon/User/account-circle-fill.svg": 596234,
	"./RemixIcon/User/account-circle-line.svg": 662111,
	"./RemixIcon/User/account-pin-box-fill.svg": 280681,
	"./RemixIcon/User/account-pin-box-line.svg": 40908,
	"./RemixIcon/User/account-pin-circle-fill.svg": 301192,
	"./RemixIcon/User/account-pin-circle-line.svg": 549397,
	"./RemixIcon/User/admin-fill.svg": 47923,
	"./RemixIcon/User/admin-line.svg": 480718,
	"./RemixIcon/User/aliens-fill.svg": 251408,
	"./RemixIcon/User/aliens-line.svg": 210365,
	"./RemixIcon/User/bear-smile-fill.svg": 776539,
	"./RemixIcon/User/bear-smile-line.svg": 478422,
	"./RemixIcon/User/body-scan-fill.svg": 884354,
	"./RemixIcon/User/body-scan-line.svg": 375575,
	"./RemixIcon/User/contacts-fill.svg": 216633,
	"./RemixIcon/User/contacts-line.svg": 794332,
	"./RemixIcon/User/criminal-fill.svg": 309685,
	"./RemixIcon/User/criminal-line.svg": 84600,
	"./RemixIcon/User/emotion-2-fill.svg": 855442,
	"./RemixIcon/User/emotion-2-line.svg": 198951,
	"./RemixIcon/User/emotion-fill.svg": 455285,
	"./RemixIcon/User/emotion-happy-fill.svg": 892382,
	"./RemixIcon/User/emotion-happy-line.svg": 945939,
	"./RemixIcon/User/emotion-laugh-fill.svg": 352165,
	"./RemixIcon/User/emotion-laugh-line.svg": 728424,
	"./RemixIcon/User/emotion-line.svg": 840568,
	"./RemixIcon/User/emotion-normal-fill.svg": 934767,
	"./RemixIcon/User/emotion-normal-line.svg": 306314,
	"./RemixIcon/User/emotion-sad-fill.svg": 114884,
	"./RemixIcon/User/emotion-sad-line.svg": 802849,
	"./RemixIcon/User/emotion-unhappy-fill.svg": 179515,
	"./RemixIcon/User/emotion-unhappy-line.svg": 430966,
	"./RemixIcon/User/genderless-fill.svg": 368904,
	"./RemixIcon/User/genderless-line.svg": 617109,
	"./RemixIcon/User/ghost-2-fill.svg": 898876,
	"./RemixIcon/User/ghost-2-line.svg": 752697,
	"./RemixIcon/User/ghost-fill.svg": 1659,
	"./RemixIcon/User/ghost-line.svg": 114038,
	"./RemixIcon/User/ghost-smile-fill.svg": 867750,
	"./RemixIcon/User/ghost-smile-line.svg": 813563,
	"./RemixIcon/User/group-2-fill.svg": 879544,
	"./RemixIcon/User/group-2-line.svg": 924037,
	"./RemixIcon/User/group-fill.svg": 508911,
	"./RemixIcon/User/group-line.svg": 880458,
	"./RemixIcon/User/men-fill.svg": 655916,
	"./RemixIcon/User/men-line.svg": 917417,
	"./RemixIcon/User/mickey-fill.svg": 543810,
	"./RemixIcon/User/mickey-line.svg": 35031,
	"./RemixIcon/User/open-arm-fill.svg": 863031,
	"./RemixIcon/User/open-arm-line.svg": 629778,
	"./RemixIcon/User/parent-fill.svg": 860348,
	"./RemixIcon/User/parent-line.svg": 230521,
	"./RemixIcon/User/robot-fill.svg": 619672,
	"./RemixIcon/User/robot-line.svg": 166181,
	"./RemixIcon/User/skull-2-fill.svg": 521642,
	"./RemixIcon/User/skull-2-line.svg": 364671,
	"./RemixIcon/User/skull-fill.svg": 893885,
	"./RemixIcon/User/skull-line.svg": 681792,
	"./RemixIcon/User/spy-fill.svg": 642078,
	"./RemixIcon/User/spy-line.svg": 462291,
	"./RemixIcon/User/star-smile-fill.svg": 661757,
	"./RemixIcon/User/star-smile-line.svg": 449664,
	"./RemixIcon/User/team-fill.svg": 193913,
	"./RemixIcon/User/team-line.svg": 771612,
	"./RemixIcon/User/travesti-fill.svg": 359686,
	"./RemixIcon/User/travesti-line.svg": 171163,
	"./RemixIcon/User/user-2-fill.svg": 716856,
	"./RemixIcon/User/user-2-line.svg": 761349,
	"./RemixIcon/User/user-3-fill.svg": 1787,
	"./RemixIcon/User/user-3-line.svg": 253238,
	"./RemixIcon/User/user-4-fill.svg": 492482,
	"./RemixIcon/User/user-4-line.svg": 653079,
	"./RemixIcon/User/user-5-fill.svg": 376333,
	"./RemixIcon/User/user-5-line.svg": 675344,
	"./RemixIcon/User/user-6-fill.svg": 271652,
	"./RemixIcon/User/user-6-line.svg": 682817,
	"./RemixIcon/User/user-add-fill.svg": 459745,
	"./RemixIcon/User/user-add-line.svg": 210788,
	"./RemixIcon/User/user-fill.svg": 116655,
	"./RemixIcon/User/user-follow-fill.svg": 282927,
	"./RemixIcon/User/user-follow-line.svg": 950474,
	"./RemixIcon/User/user-heart-fill.svg": 439578,
	"./RemixIcon/User/user-heart-line.svg": 366831,
	"./RemixIcon/User/user-line.svg": 488202,
	"./RemixIcon/User/user-location-fill.svg": 852797,
	"./RemixIcon/User/user-location-line.svg": 640704,
	"./RemixIcon/User/user-received-2-fill.svg": 280542,
	"./RemixIcon/User/user-received-2-line.svg": 334099,
	"./RemixIcon/User/user-received-fill.svg": 485849,
	"./RemixIcon/User/user-received-line.svg": 181116,
	"./RemixIcon/User/user-search-fill.svg": 57274,
	"./RemixIcon/User/user-search-line.svg": 795855,
	"./RemixIcon/User/user-settings-fill.svg": 21127,
	"./RemixIcon/User/user-settings-line.svg": 395426,
	"./RemixIcon/User/user-shared-2-fill.svg": 803208,
	"./RemixIcon/User/user-shared-2-line.svg": 144469,
	"./RemixIcon/User/user-shared-fill.svg": 827295,
	"./RemixIcon/User/user-shared-line.svg": 351738,
	"./RemixIcon/User/user-smile-fill.svg": 112906,
	"./RemixIcon/User/user-smile-line.svg": 191135,
	"./RemixIcon/User/user-star-fill.svg": 638454,
	"./RemixIcon/User/user-star-line.svg": 278987,
	"./RemixIcon/User/user-unfollow-fill.svg": 529280,
	"./RemixIcon/User/user-unfollow-line.svg": 465581,
	"./RemixIcon/User/user-voice-fill.svg": 463260,
	"./RemixIcon/User/user-voice-line.svg": 198809,
	"./RemixIcon/User/women-fill.svg": 195790,
	"./RemixIcon/User/women-line.svg": 474371,
	"./RemixIcon/Weather/blaze-fill.svg": 33319,
	"./RemixIcon/Weather/blaze-line.svg": 328450,
	"./RemixIcon/Weather/celsius-fill.svg": 237187,
	"./RemixIcon/Weather/celsius-line.svg": 50398,
	"./RemixIcon/Weather/cloud-windy-fill.svg": 420470,
	"./RemixIcon/Weather/cloud-windy-line.svg": 458123,
	"./RemixIcon/Weather/cloudy-2-fill.svg": 81262,
	"./RemixIcon/Weather/cloudy-2-line.svg": 461347,
	"./RemixIcon/Weather/cloudy-fill.svg": 648329,
	"./RemixIcon/Weather/cloudy-line.svg": 175148,
	"./RemixIcon/Weather/drizzle-fill.svg": 345913,
	"./RemixIcon/Weather/drizzle-line.svg": 923612,
	"./RemixIcon/Weather/earthquake-fill.svg": 457752,
	"./RemixIcon/Weather/earthquake-line.svg": 740837,
	"./RemixIcon/Weather/fahrenheit-fill.svg": 535751,
	"./RemixIcon/Weather/fahrenheit-line.svg": 356002,
	"./RemixIcon/Weather/fire-fill.svg": 903629,
	"./RemixIcon/Weather/fire-line.svg": 324176,
	"./RemixIcon/Weather/flashlight-fill.svg": 345535,
	"./RemixIcon/Weather/flashlight-line.svg": 355930,
	"./RemixIcon/Weather/flood-fill.svg": 547811,
	"./RemixIcon/Weather/flood-line.svg": 870142,
	"./RemixIcon/Weather/foggy-fill.svg": 950007,
	"./RemixIcon/Weather/foggy-line.svg": 200402,
	"./RemixIcon/Weather/hail-fill.svg": 82671,
	"./RemixIcon/Weather/hail-line.svg": 454218,
	"./RemixIcon/Weather/haze-2-fill.svg": 852948,
	"./RemixIcon/Weather/haze-2-line.svg": 571057,
	"./RemixIcon/Weather/haze-fill.svg": 540323,
	"./RemixIcon/Weather/haze-line.svg": 698878,
	"./RemixIcon/Weather/heavy-showers-fill.svg": 465738,
	"./RemixIcon/Weather/heavy-showers-line.svg": 15263,
	"./RemixIcon/Weather/meteor-fill.svg": 812285,
	"./RemixIcon/Weather/meteor-line.svg": 433344,
	"./RemixIcon/Weather/mist-fill.svg": 899576,
	"./RemixIcon/Weather/mist-line.svg": 63301,
	"./RemixIcon/Weather/moon-clear-fill.svg": 475180,
	"./RemixIcon/Weather/moon-clear-line.svg": 220329,
	"./RemixIcon/Weather/moon-cloudy-fill.svg": 998839,
	"./RemixIcon/Weather/moon-cloudy-line.svg": 697490,
	"./RemixIcon/Weather/moon-fill.svg": 427212,
	"./RemixIcon/Weather/moon-foggy-fill.svg": 408433,
	"./RemixIcon/Weather/moon-foggy-line.svg": 602100,
	"./RemixIcon/Weather/moon-line.svg": 458569,
	"./RemixIcon/Weather/rainbow-fill.svg": 969573,
	"./RemixIcon/Weather/rainbow-line.svg": 345832,
	"./RemixIcon/Weather/rainy-fill.svg": 323934,
	"./RemixIcon/Weather/rainy-line.svg": 377491,
	"./RemixIcon/Weather/showers-fill.svg": 681632,
	"./RemixIcon/Weather/showers-line.svg": 457997,
	"./RemixIcon/Weather/snowy-fill.svg": 459657,
	"./RemixIcon/Weather/snowy-line.svg": 673452,
	"./RemixIcon/Weather/sun-cloudy-fill.svg": 197196,
	"./RemixIcon/Weather/sun-cloudy-line.svg": 228553,
	"./RemixIcon/Weather/sun-fill.svg": 752817,
	"./RemixIcon/Weather/sun-foggy-fill.svg": 695476,
	"./RemixIcon/Weather/sun-foggy-line.svg": 671825,
	"./RemixIcon/Weather/sun-line.svg": 430132,
	"./RemixIcon/Weather/temp-cold-fill.svg": 627236,
	"./RemixIcon/Weather/temp-cold-line.svg": 612801,
	"./RemixIcon/Weather/temp-hot-fill.svg": 342865,
	"./RemixIcon/Weather/temp-hot-line.svg": 228628,
	"./RemixIcon/Weather/thunderstorms-fill.svg": 987727,
	"./RemixIcon/Weather/thunderstorms-line.svg": 655978,
	"./RemixIcon/Weather/tornado-fill.svg": 192994,
	"./RemixIcon/Weather/tornado-line.svg": 636215,
	"./RemixIcon/Weather/typhoon-fill.svg": 59266,
	"./RemixIcon/Weather/typhoon-line.svg": 550487,
	"./RemixIcon/Weather/windy-fill.svg": 364650,
	"./RemixIcon/Weather/windy-line.svg": 197759
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 771525;